export const reloadArrowsSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 32 32'
    width='32px'
    height='32px'
  >
    <path d='M 16 4 C 10.886719 4 6.617188 7.160156 4.875 11.625 L 6.71875 12.375 C 8.175781 8.640625 11.710938 6 16 6 C 19.242188 6 22.132813 7.589844 23.9375 10 L 20 10 L 20 12 L 27 12 L 27 5 L 25 5 L 25 8.09375 C 22.808594 5.582031 19.570313 4 16 4 Z M 25.28125 19.625 C 23.824219 23.359375 20.289063 26 16 26 C 12.722656 26 9.84375 24.386719 8.03125 22 L 12 22 L 12 20 L 5 20 L 5 27 L 7 27 L 7 23.90625 C 9.1875 26.386719 12.394531 28 16 28 C 21.113281 28 25.382813 24.839844 27.125 20.375 Z' />
  </svg>
);

export const connectSVG = (
  <svg viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M5.64066 24.3583C8.7812 27.3493 12.52 26.1529 14.0155 24.9415C14.7892 24.3148 15.1371 23.9097 15.4361 23.6105C16.483 22.6384 16.4157 21.6664 15.7352 20.8888C15.463 20.5776 13.7163 18.8998 12.0414 17.1799C11.174 16.3124 10.5758 15.6994 10.0643 15.2059C9.3794 14.5232 8.78121 13.7403 7.88391 13.7627C7.06138 13.7627 6.46318 14.488 5.71543 15.2358C4.85525 16.0959 4.21995 17.1799 3.99562 18.1521C3.32265 20.9934 4.3695 23.0123 5.64066 24.3583ZM5.64066 24.3583L2.50012 27.4988'
      stroke='#666666'
      strokeWidth='1.5'
      strokeLinecap='round'
    />
    <path
      d='M24.3583 5.64349C21.217 2.65106 17.4911 3.87 15.9952 5.08193C15.2212 5.70899 14.8733 6.11432 14.5741 6.41357C13.527 7.38609 13.5943 8.35863 14.275 9.13665C14.3728 9.2486 14.6615 9.53728 15.0687 9.9411M24.3583 5.64349C25.63 6.99008 26.691 9.03193 26.0177 11.8747C25.7933 12.8472 25.158 13.9317 24.2975 14.7924C23.5496 15.5405 22.9512 16.2661 22.1285 16.2661C21.2308 16.2885 20.7651 15.6395 20.08 14.9565M24.3583 5.64349L27.4998 2.50146M15.0687 9.9411C15.7943 10.6605 16.8968 11.7452 17.9698 12.8472C18.8375 13.7152 19.5683 14.4627 20.08 14.9565M15.0687 9.9411L13.1392 11.8827M20.08 14.9565L18.128 16.8621'
      stroke='#666666'
      strokeWidth='1.5'
      strokeLinecap='round'
    />
  </svg>
);
export const cmsSettingsSVG = (
  <svg version='1.1' viewBox='0 0 2048 2048' xmlns='http://www.w3.org/2000/svg'>
    <path
      transform='translate(864,175)'
      d='m0 0h316l15 2 10 5 10 9 7 14 1 4v98l7 1 33 10 30 11 27 11 35 16 25 13 11 6h4l3-4h2l2-4 12-12h2l2-4h2l2-4h2l2-4 4-4h2l2-4 4-4h2l2-4h2l2-4 8-8h2v-2l8-6 8-4 7-2h14l11 4 9 6 228 228 7 11 3 10v12l-3 10-9 13-62 62 1 6 18 35 12 25 14 34 8 21 11 34 4 14v3h98l10 3 10 7 7 8 4 7 2 8v125h131l14 2 10 5 10 10 7 13v25l-3 3-7 10-8 7-8 4-10 2h-834l-13-4-8-6-8-9-5-12-1-9 2-13 5-10 8-9 11-6 6-2 7-1 173-1-5-29-7-27-9-26-8-18-11-22-14-23-14-19-11-13-7-8-7-7v-2l-4-2v-2l-4-2-9-9-10-8-17-13-15-10-15-9-23-12-24-10-27-9-26-6-26-4-35-2h-12l-30 2-26 4-25 6-33 11-24 11-21 11-19 12-19 14-14 12-12 11-18 18-11 14-8 10-7 10-12 19-11 20-12 27-10 30-6 25-5 26h169l16 2 11 6 5 4 7 10 4 10v18l-4 10-7 9-7 6-8 4-10 2h-834l-13-4-9-7-7-8-5-10v-23l7-12 6-7 14-8 10-2h134v-119l2-11 6-12 9-9 11-6 4-1 23-1h77l4-16 12-37 10-26 11-26 13-28 10-19 8-15-1-5-62-62-6-9-4-9-1-3v-14l4-11 6-9 3-4h2v-2h2v-2l7-6 1-2h2v-2h2v-2h2v-2h2v-2h2v-2h2v-2h2v-2h2v-2h2v-2h2v-2h2v-2h2v-2h2v-2h2v-2h2v-2h2v-2l7-6 5-6 7-6 5-6h2v-2h2v-2h2v-2h2v-2h2v-2h2v-2l7-6 1-2h2v-2h2v-2l7-6 1-2h2v-2h2v-2l7-6 1-2h2v-2h2v-2l7-6 1-2h2v-2h2v-2l4-4h2v-2h2v-2h2v-2h2v-2l4-4h2v-2h2v-2l7-6 1-2h2v-2h2v-2h2v-2h2v-2l7-6 5-6 7-6 5-6 7-6 5-6 6-5 6-7h2l2-4h2l2-4 10-8 11-5 4-1h14l11 4 9 6 64 64 6-1 26-14 33-16 31-13 30-11 31-10 11-3h3v-89l2-14 6-12 9-9 11-6zm42 81-1 85-2 10-5 10-7 8-12 6-32 9-27 8-27 9-32 13-24 11-19 9-23 13-14 8-16 9-10 3h-14l-10-3-10-7-57-57-5 1-9 9v2l-4 2-10 10v2l-4 2-120 120v2l-4 2-6 6v2l-4 2-3 4 50 50 1 2h2l2 4 7 8 5 10 2 12-2 13-7 14-9 15-9 16-15 29-14 31-13 34-11 33-11 41-5 12-7 9-10 6-9 3-10 1-79 1-1 17v60h358l2-10 5-30 5-23 8-27 9-24 7-17 8-16 13-24 12-19 13-18 11-14 12-14 15-16 12-12 8-7 14-12 16-12 16-11 21-13 22-12 26-12 27-10 27-8 28-6 25-4 19-2 19-1h27l29 2 30 4 24 5 22 6 30 10 26 11 26 13 17 10 21 14 16 12 11 9 13 11 15 14 8 8 7 8 9 10 8 10 12 16 14 21 13 22 11 21 12 28 12 36 7 29 5 30 2 14 356 1 2-1v-77l-82-1-12-2-10-5-7-6-6-9-5-15-7-27-9-29-8-23-11-27-10-23-8-16-12-23-16-27-6-12-2-8v-8l3-12 5-9 9-10 51-51-1-4-163-163-3-1-60 60-14 7-5 1h-14l-12-4-27-16-22-12-15-8-31-14-36-14-40-13-38-10-12-6-7-6-6-10-3-10-1-88z'
    />
    <path
      transform='translate(795,1222)'
      d='m0 0h16l10 3 11 8 8 11 14 25 13 23 15 27 13 23 15 27 13 23 14 25 13 23 10 18 14 25 13 23 15 27 12 21 10 18 13 23 7 12 1 3 3 1 2-6 10-18 12-21 14-25 15-27 13-23 9-16 14-25 15-27 12-21 14-25 15-27 28-50 13-23 15-27 9-14 7-7 12-6 4-1h16l9 3 10 6 7 8 5 10 2 8v552l-2 11-5 9-9 10-12 6-8 2h-9l-12-3-9-6-5-5-4-5-4-8-2-6-1-378v-16l-16 28-16 29-13 23-15 27-13 23-15 27-12 21-15 27-13 23-11 19-6 11-16 29-9 14-7 7-12 6-9 2h-8l-12-3-9-6-5-5-6-8-42-75-13-23-42-75-13-23-15-27-13-23-15-27-12-21-1 387-2 12-6 12-7 7-10 6-11 3h-10l-13-4-8-6-7-7-5-10-2-7-1-14v-500l1-44 3-10 7-10 9-8 9-4z'
    />
    <path
      transform='translate(389,1215)'
      d='m0 0h110l23 3 21 6 16 7 15 8 14 10 10 8 16 16 12 16 10 17 8 19 6 21 3 20v23l-4 11-6 8-9 8-9 4-14 2-11-2-10-5-8-7-6-9-3-8-3-27-5-16-8-15-8-10-11-10-14-8-12-5-15-3h-104l-15 3-13 5-10 6-10 8-8 8-8 12-7 16-3 13-1 23v299l2 16 4 13 7 14 7 9 4 5 11 9 14 8 14 5 9 2 10 1h78l21-1 16-4 12-5 11-7 10-9 8-9 8-14 5-15 2-9 2-21 5-12 6-8h2v-2l12-7 7-2h15l12 4 9 7 7 8 5 13v24l-3 20-6 21-8 18-6 11-8 12-8 10-9 10-7 7-13 10-14 9-15 8-22 8-17 4-15 2-15 1h-86l-22-2-17-3-24-8-23-12-14-10-11-10-8-7-7-8-10-13-9-15-9-19-5-15-3-12-2-14-1-13v-321l2-17 4-18 6-18 9-19 9-14 10-13 7-7 5-6 8-7 15-11 15-9 18-8 16-5 20-4z'
    />
    <path
      transform='translate(1613,1197)'
      d='m0 0h21l24 3 17 4 20 7 17 8 16 10 11 8 13 11 13 13 13 17 5 11 1 4v14l-4 11-7 10-7 6-11 5-5 1h-14l-10-3-10-7-13-15-5-6-11-9-11-7-12-6-15-5-10-2-21-1-18 2-16 5-16 8-12 8-12 11-8 10-8 13-6 14-5 19-1 8v19l3 16 4 13 8 16 7 11 12 13 13 10 14 8 13 5 13 3 18 2 27 2 17 3 18 5 15 6 16 8 15 9 13 10 12 11 13 13 12 16 9 15 8 16 7 18 5 19 3 18v41l-4 22-5 18-6 15-8 16-9 15-11 15h-2l-2 4-7 8-8 7-13 11-17 11-21 11-27 9-25 5-9 1h-31l-20-3-23-6-22-9-17-9-17-12-14-12-10-10-9-11-12-17-7-12-4-12v-13l3-10 6-10 9-8 11-5 4-1h14l10 3 9 6 5 5 6 8 10 15 8 10 2 1v2l4 2 10 8 16 9 17 6 19 3h19l17-3 17-6 16-9 14-11 10-11 10-15 7-16 4-16 1-6v-26l-3-16-7-19-9-15-8-10-9-9-14-10-16-8-16-5-12-2-34-2-26-5-24-8-17-8-18-11-14-11-12-11-9-9-11-14-7-10-9-16-8-18-6-18-5-25-1-10v-27l3-23 5-20 8-21 11-21 9-13 10-13 6-7h2l2-4 16-14 16-11 13-8 18-8 21-7 20-4z'
    />
    <path
      transform='translate(1015,988)'
      d='m0 0h18l10 4 6 4 5 5 6 8 4 10v17l-4 11-7 9-7 6-11 5-5 1h-12l-11-3-9-6-7-7-6-12-1-3v-18l3-8 6-10 8-7 10-5z'
    />
  </svg>
);

export const completeShopCustomizationSVG = (
  <svg viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M2.81953 19.5403C2.86198 19.1363 3.15474 18.8106 3.74028 18.1595L5.02912 16.7186C5.34415 16.3197 5.56772 15.625 5.56772 14.9997C5.56772 14.375 5.34408 13.68 5.02908 13.2812L3.74028 11.8404C3.15474 11.1892 2.86197 10.8636 2.81953 10.4596C2.77708 10.0556 2.99578 9.67604 3.43317 8.91698L4.05014 7.84622C4.51677 7.03644 4.75007 6.63154 5.14704 6.47009C5.54402 6.30863 5.99297 6.43604 6.89089 6.69084L8.41618 7.12046C8.98944 7.25265 9.59088 7.17766 10.1143 6.90872L10.5354 6.66576C10.9843 6.37828 11.3295 5.9544 11.5206 5.45616L11.9381 4.20942C12.2125 3.38441 12.3498 2.9719 12.6765 2.73595C13.0033 2.5 13.4373 2.5 14.3051 2.5H15.6986C16.5666 2.5 17.0006 2.5 17.3273 2.73595C17.654 2.9719 17.7913 3.38441 18.0658 4.20942L18.4831 5.45616C18.6743 5.9544 19.0195 6.37828 19.4684 6.66576L19.8895 6.90872C20.4129 7.17766 21.0144 7.25265 21.5876 7.12046L23.1129 6.69084C24.0108 6.43604 24.4598 6.30863 24.8568 6.47009C25.2538 6.63154 25.487 7.03644 25.9536 7.84622L26.5706 8.91698C27.008 9.67604 27.2266 10.0556 27.1843 10.4596C27.1418 10.8636 26.849 11.1892 26.2635 11.8404L24.9746 13.2812C24.6598 13.68 24.436 14.375 24.436 14.9997C24.436 15.625 24.6596 16.3197 24.9746 16.7186L26.2635 18.1595C26.849 18.8106 27.1418 19.1363 27.1843 19.5403C27.2266 19.9444 27.008 20.3239 26.5706 21.0829L25.9536 22.1536C25.487 22.9634 25.2538 23.3684 24.8568 23.5297C24.4598 23.6912 24.0108 23.5639 23.1129 23.309L21.5876 22.8794C21.0143 22.7471 20.4128 22.8222 19.8893 23.0912L19.4683 23.3343C19.0194 23.6218 18.6743 24.0455 18.4833 24.5438L18.0658 25.7906C17.7913 26.6156 17.654 27.0281 17.3273 27.264C17.0006 27.5 16.5666 27.5 15.6986 27.5H14.3051C13.4373 27.5 13.0033 27.5 12.6765 27.264C12.3498 27.0281 12.2125 26.6156 11.9381 25.7906'
      stroke='#666666'
      strokeWidth='1.5'
      strokeLinecap='round'
    />
    <path
      d='M3.4218 23.4748C4.7718 22.1248 9.36181 17.5798 9.81181 17.0548C10.2875 16.4998 9.90181 15.7498 10.1313 13.4248C10.2423 12.2998 10.4843 11.4569 11.1768 10.8298C12.0018 10.0498 12.6767 10.0498 15.0017 9.99726C17.0267 10.0498 17.2667 9.82475 17.4767 10.3498C17.6267 10.7248 17.1767 10.9498 16.6367 11.5498C15.4367 12.7498 14.7317 13.3498 14.6642 13.7248C14.1767 15.3748 16.0967 16.3498 17.1467 15.2998C17.5439 14.9026 19.3817 13.0498 19.5617 12.8998C19.6967 12.7798 20.02 12.7855 20.1767 12.9748C20.3117 13.1074 20.3267 13.1248 20.3117 13.7248C20.2979 14.2801 20.3041 15.0775 20.3057 15.8998C20.308 16.9651 20.2517 18.1498 19.8017 18.7498C18.9017 20.0998 17.4017 20.1748 16.0517 20.2348C14.7767 20.3098 13.7267 20.1748 13.3967 20.4148C13.1267 20.5498 11.7018 22.0498 9.97681 23.7748L6.90181 26.8498C4.35181 28.8748 1.54681 25.7248 3.4218 23.4748Z'
      stroke='#666666'
      strokeWidth='1.5'
      strokeLinecap='round'
    />
  </svg>
);

export const aiCheckoutSVG = (
  <svg viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M5 15C5 10.286 5 7.92894 6.46446 6.46446C7.92894 5 10.286 5 15 5C19.714 5 22.0711 5 23.5355 6.46446C25 7.92894 25 10.286 25 15C25 19.714 25 22.0711 23.5355 23.5355C22.0711 25 19.714 25 15 25C10.286 25 7.92894 25 6.46446 23.5355C5 22.0711 5 19.714 5 15Z'
      stroke='#666666'
      strokeWidth='1.5'
      strokeLinejoin='round'
    />
    <path
      d='M9.375 18.75L11.6774 11.8429C11.7954 11.4888 12.1268 11.25 12.5 11.25C12.8732 11.25 13.2046 11.4888 13.3226 11.8429L15.625 18.75M10.625 16.25H14.375'
      stroke='#666666'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M19.375 11.25V18.75'
      stroke='#666666'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M10 2.5V5M20 2.5V5M15 2.5V5M10 25V27.5M15 25V27.5M20 25V27.5M27.5 20H25M5 10H2.5M5 20H2.5M5 15H2.5M27.5 10H25M27.5 15H25'
      stroke='#666666'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
export const dashboardSVG = (
  <svg
    clipRule='evenodd'
    fillRule='evenodd'
    strokeLinejoin='round'
    strokeMiterlimit='2'
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='m11.6 11c0-.552-.448-1-1-1-1.655 0-4.945 0-6.6 0-.552 0-1 .448-1 1v9c0 .552.448 1 1 1h6.6c.552 0 1-.448 1-1 0-2.092 0-6.908 0-9zm9.4 6c0-.552-.448-1-1-1h-6c-.538 0-1 .477-1 1v3c0 .552.448 1 1 1h6c.552 0 1-.448 1-1zm-1.5.5v2h-5v-2zm-9.4-6v8h-5.6v-8zm10.9-7.5c0-.552-.448-1-1-1-1.537 0-4.463 0-6 0-.552 0-1 .448-1 1v9.6c0 .552.448 1 1 1h6c.552 0 1-.448 1-1 0-2.194 0-7.406 0-9.6zm-1.5.5v8.6h-5v-8.6zm-7.9-.5c0-.552-.448-1-1-1-1.655 0-4.945 0-6.6 0-.552 0-1 .448-1 1v3.6c0 .552.448 1 1 1h6.6c.552 0 1-.448 1-1 0-1.017 0-2.583 0-3.6zm-1.5.5v2.6h-5.6v-2.6z'
      fillRule='nonzero'
    />
  </svg>
);
export const equalizerSVG = (
  <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      d='M8,12 C8,13.3062521 7.1651499,14.4175144 5.99991107,14.8293257 L6,21 C6,21.5522847 5.55228475,22 5,22 C4.44771525,22 4,21.5522847 4,21 L3.99909928,14.8289758 C2.83437743,14.4168852 2,13.3058822 2,12 C2,10.6941178 2.83437743,9.58311485 3.99909928,9.17102423 L4,3 C4,2.44771525 4.44771525,2 5,2 C5.55228475,2 6,2.44771525 6,3 L5.99991107,9.17067428 C7.1651499,9.58248558 8,10.6937479 8,12 Z M6,12 C6,11.4477153 5.55228475,11 5,11 C4.44771525,11 4,11.4477153 4,12 C4,12.5522847 4.44771525,13 5,13 C5.55228475,13 6,12.5522847 6,12 Z M15,19 C15,20.6568542 13.6568542,22 12,22 C10.3431458,22 9,20.6568542 9,19 C9,17.6941178 9.83437743,16.5831148 10.9990993,16.1710242 L11,3 C11,2.44771525 11.4477153,2 12,2 C12.5522847,2 13,2.44771525 13,3 L12.9999111,16.1706743 C14.1651499,16.5824856 15,17.6937479 15,19 Z M13,19 C13,18.4477153 12.5522847,18 12,18 C11.4477153,18 11,18.4477153 11,19 C11,19.5522847 11.4477153,20 12,20 C12.5522847,20 13,19.5522847 13,19 Z M22,5 C22,6.31179956 21.1580438,7.42694971 19.9850473,7.83453458 C19.9953052,7.88798638 20,7.94344492 20,8 L20,21 C20,21.5522847 19.5522847,22 19,22 C18.4477153,22 18,21.5522847 18,21 L18,8 C18,7.94344492 18.0046948,7.88798638 18.013716,7.83399285 C16.8419562,7.42694971 16,6.31179956 16,5 C16,3.34314575 17.3431458,2 19,2 C20.6568542,2 22,3.34314575 22,5 Z M20,5 C20,4.44771525 19.5522847,4 19,4 C18.4477153,4 18,4.44771525 18,5 C18,5.55228475 18.4477153,6 19,6 C19.5522847,6 20,5.55228475 20,5 Z'
    />
  </svg>
);
export const search2SVG = (
  <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
    <path d='M21.71,20.29,18,16.61A9,9,0,1,0,16.61,18l3.68,3.68a1,1,0,0,0,1.42,0A1,1,0,0,0,21.71,20.29ZM11,18a7,7,0,1,1,7-7A7,7,0,0,1,11,18Z' />
  </svg>
);
export const targetSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M12 4c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8zm0-2c-5.523 0-10 4.477-10 10s4.477 10 10 10 10-4.477 10-10-4.477-10-10-10zm0 6c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4zm0-2c-3.314 0-6 2.686-6 6s2.686 6 6 6 6-2.686 6-6-2.686-6-6-6zm0 4c-1.105 0-2 .896-2 2s.895 2 2 2 2-.896 2-2-.895-2-2-2z' />
  </svg>
);
export const trendLineSVG = (
  <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
    <path d='M20.684 4.042A1.029 1.029 0 0 1 22 5.03l-.001 5.712a1.03 1.03 0 0 1-1.647.823L18.71 10.33l-4.18 5.568a1.647 1.647 0 0 1-2.155.428l-.15-.1-3.337-2.507-4.418 5.885c-.42.56-1.185.707-1.777.368l-.144-.095a1.372 1.372 0 0 1-.368-1.776l.095-.144 5.077-6.762a1.646 1.646 0 0 1 2.156-.428l.149.1 3.336 2.506 3.522-4.69-1.647-1.237a1.03 1.03 0 0 1 .194-1.76l.137-.05 5.485-1.595-.001.001z' />
  </svg>
);
export const cursorSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <path d='m3 3 7.07 16.97 2.51-7.39 7.39-2.51L3 3z'></path>
    <path d='m13 13 6 6'></path>
  </svg>
);
export const funnelSVG = (
  <svg
    viewBox='-2 -2 24 24'
    xmlns='http://www.w3.org/2000/svg'
    preserveAspectRatio='xMinYMin'
  >
    <path d='M2.08 2l6.482 8.101A2 2 0 0 1 9 11.351V18l2-1.5v-5.15a2 2 0 0 1 .438-1.249L17.92 2H2.081zm0-2h15.84a2 2 0 0 1 1.561 3.25L13 11.35v5.15a2 2 0 0 1-.8 1.6l-2 1.5A2 2 0 0 1 7 18v-6.65L.519 3.25A2 2 0 0 1 2.08 0z' />
  </svg>
);
export const dollarSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm4 14.083c0-2.145-2.232-2.742-3.943-3.546-1.039-.54-.908-1.829.581-1.916.826-.05 1.675.195 2.443.465l.362-1.647c-.907-.276-1.719-.402-2.443-.421v-1.018h-1v1.067c-1.945.267-2.984 1.487-2.984 2.85 0 2.438 2.847 2.81 3.778 3.243 1.27.568 1.035 1.75-.114 2.011-.997.226-2.269-.168-3.225-.54l-.455 1.644c.894.462 1.965.708 3 .727v.998h1v-1.053c1.657-.232 3.002-1.146 3-2.864z' />
  </svg>
);
export const chartBarSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M5 19h-4v-8h4v8zm6 0h-4v-18h4v18zm6 0h-4v-12h4v12zm6 0h-4v-4h4v4zm1 2h-24v2h24v-2z' />
  </svg>
);
export const dragSVG = (
  <svg
    width='24'
    height='24'
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M7.113 12.285 8 13.17l.887-.886a1 1 0 0 1 1.414 1.414L8 16l-2.302-2.3a1 1 0 0 1 1.414-1.415M3.715 5.699a1 1 0 0 1 .083 1.32l-.083.094L2.828 8l.887.887a1 1 0 0 1-1.32 1.497l-.094-.083L0 8l2.3-2.3a1 1 0 0 1 1.415-.001m9.984 0L16 8l-2.3 2.302a1 1 0 0 1-1.415-1.414L13.172 8l-.887-.887A1 1 0 1 1 13.7 5.7M8 6a1 1 0 0 1 1 1 1 1 0 1 1 0 2 1 1 0 1 1-2 0 1 1 0 1 1 0-2 1 1 0 0 1 1-1m0-6 2.3 2.3a1 1 0 1 1-1.413 1.415L8 2.828l-.887.887A1 1 0 0 1 5.7 2.301z' />
  </svg>
);
export const calendarSVG = (
  <svg
    viewBox='-2 -3 24 24'
    xmlns='http://www.w3.org/2000/svg'
    preserveAspectRatio='xMinYMin'
  >
    <path d='M18 7V5a1 1 0 0 0-1-1h-1v1a1 1 0 0 1-2 0V4H6v1a1 1 0 1 1-2 0V4H3a1 1 0 0 0-1 1v2h16zm0 2H2v6a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9zm-2-7h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h1V1a1 1 0 1 1 2 0v1h8V1a1 1 0 0 1 2 0v1z' />
  </svg>
);
export const cart2SVG = (
  <svg
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 20 20'
    enableBackground='new 0 0 20 20'
  >
    <path
      d='M17,14H4c-0.6,0-1-0.4-1-1V2H0V0h4c0.6,0,1,0.4,1,1v11h11.2l1.5-6H7V4h12c0.6,0,1.1,0.6,1,1.2l-2,8C17.9,13.7,17.5,14,17,14
	z'
    />
    <circle cx='5' cy='18' r='2' />
    <circle cx='16' cy='18' r='2' />
  </svg>
);
export const cartAbandonedSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M13.299 3.74c-.207-.206-.299-.461-.299-.711 0-.524.407-1.029 1.02-1.029.262 0 .522.1.721.298l3.783 3.783c-.771.117-1.5.363-2.158.726l-3.067-3.067zm3.92 14.84l-.571 1.42h-9.296l-3.597-8.961-.016-.039h9.441c.171-.721.459-1.395.848-2h-14.028v2h.643c.535 0 1.021.304 1.256.784l4.101 10.216h12l1.21-3.015c-.698-.03-1.367-.171-1.991-.405zm-6.518-14.84c.207-.206.299-.461.299-.711 0-.524-.407-1.029-1.02-1.029-.261 0-.522.1-.72.298l-4.701 4.702h2.883l3.259-3.26zm13.299 8.76c0 2.485-2.017 4.5-4.5 4.5s-4.5-2.015-4.5-4.5 2.017-4.5 4.5-4.5 4.5 2.015 4.5 4.5zm-3.086-2.122l-1.414 1.414-1.414-1.414-.707.708 1.414 1.414-1.414 1.414.707.708 1.414-1.414 1.414 1.414.708-.708-1.414-1.414 1.414-1.414-.708-.708z' />
  </svg>
);
export const cartAddSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M13.299 3.74c-.207-.206-.299-.461-.299-.711 0-.524.407-1.029 1.02-1.029.262 0 .522.1.721.298l3.783 3.783c-.771.117-1.5.363-2.158.726l-3.067-3.067zm3.92 14.84l-.571 1.42h-9.296l-3.597-8.961-.016-.039h9.441c.171-.721.459-1.395.848-2h-14.028v2h.643c.535 0 1.021.304 1.256.784l4.101 10.216h12l1.21-3.015c-.698-.03-1.367-.171-1.991-.405zm-6.518-14.84c.207-.206.299-.461.299-.711 0-.524-.407-1.029-1.02-1.029-.261 0-.522.1-.72.298l-4.701 4.702h2.883l3.259-3.26zm8.799 4.26c-2.484 0-4.5 2.015-4.5 4.5s2.016 4.5 4.5 4.5c2.482 0 4.5-2.015 4.5-4.5s-2.018-4.5-4.5-4.5zm2.5 5h-2v2h-1v-2h-2v-1h2v-2h1v2h2v1z' />
  </svg>
);
export const messageSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M0 3v18h24v-18h-24zm21.518 2l-9.518 7.713-9.518-7.713h19.036zm-19.518 14v-11.817l10 8.104 10-8.104v11.817h-20z' />
  </svg>
);
export const checkoutSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M21.753 15.467c1.301 1.821.939 3.104 2.247 4.938l-5.041 3.595c-2.723-2.027-5.072-2.677-5.83-2.932-.723-.243-1.189-.706-1.029-1.289.163-.589.779-.764 1.286-.741.765.035 1.386.265 1.386.265l-3.516-4.93c-.313-.44-.211-1.051.229-1.365.439-.314 1.049-.211 1.363.229l2.382 3.333c.114.161.338.199.498.084.162-.115.199-.339.085-.5l-.587-.823.944-.235c.248-.06.507.036.655.244l.48.673c.115.161.338.199.499.084s.197-.338.083-.5l-.555-.777.928-.208c.243-.052.495.045.64.247l.407.572c.114.161.339.198.5.084.16-.115.198-.339.084-.5l-.458-.641.273-.048c.953-.167 1.469.329 2.047 1.141zm-10.838-3.248c.61-.436 1.399-.45 1.987.002-.334-1.121-1.676-1.583-2.629-.902-.955.682-.952 2.1-.002 2.779-.236-.703.034-1.444.644-1.879zm5.644-7.219h2.883l-4.702-4.702c-.198-.198-.459-.298-.72-.298-.613 0-1.02.505-1.02 1.029 0 .25.092.504.299.711l3.26 3.26zm-5.858-3.26c.207-.206.299-.461.299-.711 0-.524-.407-1.029-1.02-1.029-.261 0-.522.1-.721.298l-4.701 4.702h2.883l3.26-3.26zm.184 16.26h-3.533l-3.613-9h16.522l-1.381 3.44c.803-.144 1.282-.252 2.153.002l1.067-2.657c.236-.48.724-.785 1.258-.785h.642v-2h-24v2h.643c.534 0 1.021.304 1.256.784l4.101 10.216h4.086c-.004-.79.273-1.456.799-2z' />
  </svg>
);
export const chatSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M12 3c5.514 0 10 3.592 10 8.007 0 4.917-5.145 7.961-9.91 7.961-1.937 0-3.383-.397-4.394-.644-1 .613-1.595 1.037-4.272 1.82.535-1.373.723-2.748.602-4.265-.838-1-2.025-2.4-2.025-4.872-.001-4.415 4.485-8.007 9.999-8.007zm0-2c-6.338 0-12 4.226-12 10.007 0 2.05.738 4.063 2.047 5.625.055 1.83-1.023 4.456-1.993 6.368 2.602-.47 6.301-1.508 7.978-2.536 1.418.345 2.775.503 4.059.503 7.084 0 11.91-4.837 11.91-9.961-.001-5.811-5.702-10.006-12.001-10.006zm-3.5 10c0 .829-.671 1.5-1.5 1.5-.828 0-1.5-.671-1.5-1.5s.672-1.5 1.5-1.5c.829 0 1.5.671 1.5 1.5zm3.5-1.5c-.828 0-1.5.671-1.5 1.5s.672 1.5 1.5 1.5c.829 0 1.5-.671 1.5-1.5s-.671-1.5-1.5-1.5zm5 0c-.828 0-1.5.671-1.5 1.5s.672 1.5 1.5 1.5c.829 0 1.5-.671 1.5-1.5s-.671-1.5-1.5-1.5z' />
  </svg>
);
export const mobileSVG = (
  <svg viewBox='0 0 1000 1000' xmlns='http://www.w3.org/2000/svg'>
    <path d='M718 25H282q-36 0-61.5 25.5T195 112v786q0 36 25.5 61.5T282 985h436q36 0 61.5-25.5T805 898V112q0-36-25.5-61.5T718 25zm-27 786H309q-12 0-19.5-8t-7.5-20V191q0-11 7.5-19t19.5-8h382q11 0 19 8t8 19v592q0 12-8 20t-19 8z' />
  </svg>
);
export const phoneSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M20 22.621l-3.521-6.795c-.008.004-1.974.97-2.064 1.011-2.24 1.086-6.799-7.82-4.609-8.994l2.083-1.026-3.493-6.817-2.106 1.039c-7.202 3.755 4.233 25.982 11.6 22.615.121-.055 2.102-1.029 2.11-1.033z' />
  </svg>
);
export const arrowHeadRightLightSVG = (
  <svg viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
    <g>
      <g>
        <rect width='48' height='48' fill='none' />
      </g>
      <g>
        <path d='M27.2,24,16.6,34.6a1.9,1.9,0,0,0,.2,3,2.1,2.1,0,0,0,2.7-.2l11.9-12a1.9,1.9,0,0,0,0-2.8l-11.9-12a2.1,2.1,0,0,0-2.7-.2,1.9,1.9,0,0,0-.2,3Z' />
      </g>
    </g>
  </svg>
);
export const chartSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M24 3.875l-6 1.221 1.716 1.708-5.351 5.358-3.001-3.002-7.336 7.242 1.41 1.418 5.922-5.834 2.991 2.993 6.781-6.762 1.667 1.66 1.201-6.002zm0 17.125v2h-24v-22h2v20h22z' />
  </svg>
);
export const databaseSmallSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M12 3c-4.225 0-10 .969-10 4.221v9.559c0 3.252 6.209 4.22 10.008 4.22 3.783 0 9.992-.969 9.992-4.221v-9.558c0-3.253-5.973-4.221-10-4.221zm0 1.936c3.639 0 7.992.879 7.992 2.285 0 1.53-5.104 2.285-7.992 2.285-3.412 0-8.008-.876-8.008-2.285 0-1.533 4.813-2.285 8.008-2.285zm8 11.599c0 1.694-5.104 2.53-7.992 2.53-3.412 0-8.008-.97-8.008-2.53v-1.974c2.117 1.298 5.17 1.723 8.008 1.723 2.829 0 5.876-.425 7.992-1.723v1.974zm-8-2.19c-3.426 0-8.008-.974-8.008-2.53v-2.096c2.117 1.298 5.17 1.723 8.008 1.723 2.829 0 5.876-.425 7.992-1.723v2.096c0 1.697-5.131 2.53-7.992 2.53z' />
  </svg>
);
export const databaseLargeSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M12.008 0c-4.225 0-10.008 1.001-10.008 4.361v15.277c0 3.362 6.209 4.362 10.008 4.362 3.783 0 9.992-1.001 9.992-4.361v-15.278c0-3.361-5.965-4.361-9.992-4.361zm0 2c3.638 0 7.992.909 7.992 2.361 0 1.581-5.104 2.361-7.992 2.361-3.412.001-8.008-.905-8.008-2.361 0-1.584 4.812-2.361 8.008-2.361zm7.992 17.386c0 1.751-5.104 2.614-7.992 2.614-3.412 0-8.008-1.002-8.008-2.614v-2.04c2.117 1.342 5.17 1.78 8.008 1.78 2.829 0 5.876-.438 7.992-1.78v2.04zm0-4.873c0 1.75-5.104 2.614-7.992 2.614-3.412-.001-8.008-1.002-8.008-2.614v-2.364c2.116 1.341 5.17 1.78 8.008 1.78 2.839 0 5.881-.442 7.992-1.78v2.364zm-7.992-2.585c-3.426 0-8.008-1.006-8.008-2.614v-2.371c2.117 1.342 5.17 1.78 8.008 1.78 2.829 0 5.876-.438 7.992-1.78v2.372c0 1.753-5.131 2.613-7.992 2.613z' />
  </svg>
);
export const pauseSVG = (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M16,2a3,3,0,0,0-3,3V19a3,3,0,0,0,6,0V5A3,3,0,0,0,16,2Zm1,17a1,1,0,0,1-2,0V5a1,1,0,0,1,2,0ZM8,2A3,3,0,0,0,5,5V19a3,3,0,0,0,6,0V5A3,3,0,0,0,8,2ZM9,19a1,1,0,0,1-2,0V5A1,1,0,0,1,9,5Z' />
  </svg>
);
export const completedCartSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M13.299 3.74c-.207-.206-.299-.461-.299-.711 0-.524.407-1.029 1.02-1.029.262 0 .522.1.721.298l3.783 3.783c-.771.117-1.5.363-2.158.726l-3.067-3.067zm-.299 8.76c0-1.29.381-2.489 1.028-3.5h-14.028v2h.643c.535 0 1.021.304 1.256.784l4.101 10.216h12l1.211-3.015c-3.455-.152-6.211-2.993-6.211-6.485zm-2.299-8.76c.207-.206.299-.461.299-.711 0-.524-.407-1.029-1.02-1.029-.261 0-.522.1-.72.298l-4.701 4.702h2.883l3.259-3.26zm8.799 4.26c-2.486 0-4.5 2.015-4.5 4.5s2.014 4.5 4.5 4.5c2.484 0 4.5-2.015 4.5-4.5s-2.016-4.5-4.5-4.5zm-.469 6.484l-1.688-1.637.695-.697.992.94 2.115-2.169.697.696-2.811 2.867z' />
  </svg>
);
export const addedCartSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M13.299 3.74c-.207-.206-.299-.461-.299-.711 0-.524.407-1.029 1.02-1.029.262 0 .522.1.721.298l3.783 3.783c-.771.117-1.5.363-2.158.726l-3.067-3.067zm-.299 8.76c0-1.29.38-2.489 1.028-3.5h-14.028v2h.643c.535 0 1.021.304 1.256.784l4.101 10.216h12l1.21-3.015c-3.454-.152-6.21-2.993-6.21-6.485zm-2.299-8.76c.207-.206.299-.461.299-.711 0-.524-.407-1.029-1.02-1.029-.261 0-.522.1-.72.298l-4.701 4.702h2.883l3.259-3.26zm8.799 4.26c-2.484 0-4.5 2.015-4.5 4.5s2.016 4.5 4.5 4.5c2.482 0 4.5-2.015 4.5-4.5s-2.018-4.5-4.5-4.5zm2.5 5h-2v2h-1v-2h-2v-1h2v-2h1v2h2v1z' />
  </svg>
);
export const tickWithCircleSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-1.959 17l-4.5-4.319 1.395-1.435 3.08 2.937 7.021-7.183 1.422 1.409-8.418 8.591z' />
  </svg>
);
export const keySVG = (
  <svg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.5 9C12.9853 9 15 6.98528 15 4.5C15 2.01472 12.9853 0 10.5 0C8.01475 0 6.00003 2.01472 6.00003 4.5C6.00003 5.38054 6.25294 6.20201 6.69008 6.89574L0.585815 13L3.58292 15.9971L4.99714 14.5829L3.41424 13L5.00003 11.4142L6.58292 12.9971L7.99714 11.5829L6.41424 10L8.10429 8.30995C8.79801 8.74709 9.61949 9 10.5 9ZM10.5 7C11.8807 7 13 5.88071 13 4.5C13 3.11929 11.8807 2 10.5 2C9.11932 2 8.00003 3.11929 8.00003 4.5C8.00003 5.88071 9.11932 7 10.5 7Z'
    />
  </svg>
);

export const tickSVG = (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M20.293 6.293a1 1 0 0 0-1.414 0L9 15.586 5.707 12.293a1 1 0 0 0-1.414 1.414l4 4a1 1 0 0 0 1.414 0l10-10a1 1 0 0 0 0-1.414z' />
  </svg>
);
export const historySVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M24 12c0 6.627-5.373 12-12 12s-12-5.373-12-12h2c0 5.514 4.486 10 10 10s10-4.486 10-10-4.486-10-10-10c-2.777 0-5.287 1.141-7.099 2.977l2.061 2.061-6.962 1.354 1.305-7.013 2.179 2.18c2.172-2.196 5.182-3.559 8.516-3.559 6.627 0 12 5.373 12 12zm-13-6v8h7v-2h-5v-6h-2z' />
  </svg>
);
export const support2SVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M3.402 9c.384-4.965 3.619-9 8.598-9s8.214 4.035 8.598 9h-1.734c-.411-3.955-3.167-6.436-6.864-6.428-3.697-.008-6.453 2.473-6.863 6.428h-1.735zm-1.402 3.761v4.478c0 .973.788 1.761 1.762 1.761h2.238v-8h-2.238c-.974 0-1.762.789-1.762 1.761zm18.239-1.761h-2.239v8h2.239c.974 0 1.761-.788 1.761-1.76v-4.479c0-.972-.788-1.761-1.761-1.761zm-11.239 12.029c0 .536.436.971.972.971h3.028v-2h-3.028c-.536 0-.972.493-.972 1.029zm9.952-3.029c-.554 1.77-2.189 2.51-4.952 2.51v1.021c3.213 0 5.355-1.018 6-3.531h-1.048z' />
  </svg>
);
export const tableSVG = (
  <svg
    width='24'
    height='24'
    viewBox='0 0 16 16'
    id='table-16px'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      id='Path_31'
      data-name='Path 31'
      d='M-11.5,0h-11A2.5,2.5,0,0,0-25,2.5v11A2.5,2.5,0,0,0-22.5,16h11A2.5,2.5,0,0,0-9,13.5V2.5A2.5,2.5,0,0,0-11.5,0ZM-15,4V7h-4V4Zm5,7h-4V8h4Zm-5,0h-4V8h4Zm0,1v3h-4V12Zm-9-4h4v3h-4Zm4-1h-4V4h4Zm-4,6.5V12h4v3h-2.5A1.5,1.5,0,0,1-24,13.5ZM-11.5,15H-14V12h4v1.5A1.5,1.5,0,0,1-11.5,15ZM-10,7h-4V4h4ZM-24,3V2.5A1.5,1.5,0,0,1-22.5,1h11A1.5,1.5,0,0,1-10,2.5V3Z'
      transform='translate(25)'
    />
  </svg>
);
export const giftSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M17.369 0c-2.947 0-4.671 3.478-5.369 5h5.345c3.493 0 3.53-5 .024-5zm-.796 3.621h-2.043c.739-1.121 1.438-1.966 2.342-1.966 1.172 0 1.228 1.966-.299 1.966zm-9.918 1.379h5.345c-.698-1.522-2.422-5-5.369-5-3.506 0-3.469 5 .024 5zm.473-3.345c.903 0 1.603.845 2.342 1.966h-2.043c-1.527 0-1.471-1.966-.299-1.966zm16.872 4.345h-24v6h1.056v12h21.889v-12h1.055v-6zm-13 16h-8v-10h8v10zm0-12h-9v-2h9v2zm2-2h9v2h-9v-2zm8 14h-8v-10h8v10z' />
  </svg>
);
export const thumbnailSVG = (
  <svg
    clipRule='evenodd'
    fillRule='evenodd'
    strokeLinejoin='round'
    strokeMiterlimit='2'
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='m11.3 13.7c0-.53-.47-1-1-1h-7.3c-.53 0-1 .47-1 1v5.3c0 .53.47 1 1 1h7.3c.53 0 1-.47 1-1zm10.7 0c0-.53-.47-1-1-1h-7.3c-.53 0-1 .47-1 1v5.3c0 .53.47 1 1 1h7.3c.53 0 1-.47 1-1zm-7.8.5h6.3v4.3h-6.3zm-10.7 0h6.3v4.3h-6.3zm18.5-9.2c0-.53-.47-1-1-1h-7.3c-.53 0-1 .47-1 1v5.3c0 .53.47 1 1 1h7.3c.53 0 1-.47 1-1zm-10.7 0c0-.53-.47-1-1-1h-7.3c-.53 0-1 .47-1 1v5.3c0 .53.47 1 1 1h7.3c.53 0 1-.47 1-1zm2.9.5h6.3v4.3h-6.3zm-10.7 0h6.3v4.3h-6.3z'
      fillRule='nonzero'
    />
  </svg>
);

export const chipSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M16.25 6c.414 0 .75.336.75.75v9.5c0 .414-.336.75-.75.75h-9.5c-.414 0-.75-.336-.75-.75v-9.5c0-.414.336-.75.75-.75h9.5zm2.75 0c0-1.104-.896-2-2-2h-11c-1.104 0-2 .896-2 2v11c0 1.104.896 2 2 2h11c1.104 0 2-.896 2-2v-11zm-11 14v3h-1v-3h1zm4 0v3h-1v-3h1zm2 0v3h-1v-3h1zm-4 0v3h-1v-3h1zm6 0v3h-1v-3h1zm-8-20v3h-1v-3h1zm4 0v3h-1v-3h1zm2 0v3h-1v-3h1zm-4 0v3h-1v-3h1zm6 0v3h-1v-3h1zm4 15h3v1h-3v-1zm0-4h3v1h-3v-1zm0-2h3v1h-3v-1zm0 4h3v1h-3v-1zm0-6h3v1h-3v-1zm-20 8h3v1h-3v-1zm0-4h3v1h-3v-1zm0-2h3v1h-3v-1zm0 4h3v1h-3v-1zm0-6h3v1h-3v-1z' />
  </svg>
);

export const searchSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M21.172 24l-7.387-7.387c-1.388.874-3.024 1.387-4.785 1.387-4.971 0-9-4.029-9-9s4.029-9 9-9 9 4.029 9 9c0 1.761-.514 3.398-1.387 4.785l7.387 7.387-2.828 2.828zm-12.172-8c3.859 0 7-3.14 7-7s-3.141-7-7-7-7 3.14-7 7 3.141 7 7 7z' />
  </svg>
);
export const eventSVG = (
  <svg
    clipRule='evenodd'
    fillRule='evenodd'
    strokeLinejoin='round'
    strokeMiterlimit='2'
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='m11 3h-7c-.62 0-1 .519-1 1v16c0 .621.52 1 1 1h7zm10 9.4h-8.6v8.6h7.6c.478 0 1-.379 1-1zm-8.6-9.4v8h8.6v-7c0-.478-.379-1-1-1z'
      fillRule='nonzero'
    />
  </svg>
);
export const calenderSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M17 3v-2c0-.552.447-1 1-1s1 .448 1 1v2c0 .552-.447 1-1 1s-1-.448-1-1zm-12 1c.553 0 1-.448 1-1v-2c0-.552-.447-1-1-1-.553 0-1 .448-1 1v2c0 .552.447 1 1 1zm13 13v-3h-1v4h3v-1h-2zm-5 .5c0 2.481 2.019 4.5 4.5 4.5s4.5-2.019 4.5-4.5-2.019-4.5-4.5-4.5-4.5 2.019-4.5 4.5zm11 0c0 3.59-2.91 6.5-6.5 6.5s-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5zm-14.237 3.5h-7.763v-13h19v1.763c.727.33 1.399.757 2 1.268v-9.031h-3v1c0 1.316-1.278 2.339-2.658 1.894-.831-.268-1.342-1.111-1.342-1.984v-.91h-9v1c0 1.316-1.278 2.339-2.658 1.894-.831-.268-1.342-1.111-1.342-1.984v-.91h-3v21h11.031c-.511-.601-.938-1.273-1.268-2z' />
  </svg>
);
export const searchSmallSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    x='0px'
    y='0px'
    width='122.879px'
    height='119.799px'
    viewBox='0 0 122.879 119.799'
    enableBackground='new 0 0 122.879 119.799'
  >
    <g>
      <path d='M49.988,0h0.016v0.007C63.803,0.011,76.298,5.608,85.34,14.652c9.027,9.031,14.619,21.515,14.628,35.303h0.007v0.033v0.04 h-0.007c-0.005,5.557-0.917,10.905-2.594,15.892c-0.281,0.837-0.575,1.641-0.877,2.409v0.007c-1.446,3.66-3.315,7.12-5.547,10.307 l29.082,26.139l0.018,0.016l0.157,0.146l0.011,0.011c1.642,1.563,2.536,3.656,2.649,5.78c0.11,2.1-0.543,4.248-1.979,5.971 l-0.011,0.016l-0.175,0.203l-0.035,0.035l-0.146,0.16l-0.016,0.021c-1.565,1.642-3.654,2.534-5.78,2.646 c-2.097,0.111-4.247-0.54-5.971-1.978l-0.015-0.011l-0.204-0.175l-0.029-0.024L78.761,90.865c-0.88,0.62-1.778,1.209-2.687,1.765 c-1.233,0.755-2.51,1.466-3.813,2.115c-6.699,3.342-14.269,5.222-22.272,5.222v0.007h-0.016v-0.007 c-13.799-0.004-26.296-5.601-35.338-14.645C5.605,76.291,0.016,63.805,0.007,50.021H0v-0.033v-0.016h0.007 c0.004-13.799,5.601-26.296,14.645-35.338C23.683,5.608,36.167,0.016,49.955,0.007V0H49.988L49.988,0z M50.004,11.21v0.007h-0.016 h-0.033V11.21c-10.686,0.007-20.372,4.35-27.384,11.359C15.56,29.578,11.213,39.274,11.21,49.973h0.007v0.016v0.033H11.21 c0.007,10.686,4.347,20.367,11.359,27.381c7.009,7.012,16.705,11.359,27.403,11.361v-0.007h0.016h0.033v0.007 c10.686-0.007,20.368-4.348,27.382-11.359c7.011-7.009,11.358-16.702,11.36-27.4h-0.006v-0.016v-0.033h0.006 c-0.006-10.686-4.35-20.372-11.358-27.384C70.396,15.56,60.703,11.213,50.004,11.21L50.004,11.21z' />
    </g>
  </svg>
);

export const settingSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M24 14.187v-4.374c-2.148-.766-2.726-.802-3.027-1.529-.303-.729.083-1.169 1.059-3.223l-3.093-3.093c-2.026.963-2.488 1.364-3.224 1.059-.727-.302-.768-.889-1.527-3.027h-4.375c-.764 2.144-.8 2.725-1.529 3.027-.752.313-1.203-.1-3.223-1.059l-3.093 3.093c.977 2.055 1.362 2.493 1.059 3.224-.302.727-.881.764-3.027 1.528v4.375c2.139.76 2.725.8 3.027 1.528.304.734-.081 1.167-1.059 3.223l3.093 3.093c1.999-.95 2.47-1.373 3.223-1.059.728.302.764.88 1.529 3.027h4.374c.758-2.131.799-2.723 1.537-3.031.745-.308 1.186.099 3.215 1.062l3.093-3.093c-.975-2.05-1.362-2.492-1.059-3.223.3-.726.88-.763 3.027-1.528zm-4.875.764c-.577 1.394-.068 2.458.488 3.578l-1.084 1.084c-1.093-.543-2.161-1.076-3.573-.49-1.396.581-1.79 1.693-2.188 2.877h-1.534c-.398-1.185-.791-2.297-2.183-2.875-1.419-.588-2.507-.045-3.579.488l-1.083-1.084c.557-1.118 1.066-2.18.487-3.58-.579-1.391-1.691-1.784-2.876-2.182v-1.533c1.185-.398 2.297-.791 2.875-2.184.578-1.394.068-2.459-.488-3.579l1.084-1.084c1.082.538 2.162 1.077 3.58.488 1.392-.577 1.785-1.69 2.183-2.875h1.534c.398 1.185.792 2.297 2.184 2.875 1.419.588 2.506.045 3.579-.488l1.084 1.084c-.556 1.121-1.065 2.187-.488 3.58.577 1.391 1.689 1.784 2.875 2.183v1.534c-1.188.398-2.302.791-2.877 2.183zm-7.125-5.951c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3zm0-2c-2.762 0-5 2.238-5 5s2.238 5 5 5 5-2.238 5-5-2.238-5-5-5z' />
  </svg>
);

export const extensionSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M3.111,23H8.667a1,1,0,0,0,1-1V19.9a1.316,1.316,0,0,1,1.009-1.323,1.224,1.224,0,0,1,1.435,1.2V22a1,1,0,0,0,1,1h3.334a2.113,2.113,0,0,0,2.111-2.111V17.444h1.222a3.224,3.224,0,0,0,3.179-3.756A3.314,3.314,0,0,0,19.659,11h-1.1V7.555a2.113,2.113,0,0,0-2.111-2.111H13V4.34a3.313,3.313,0,0,0-2.688-3.3A3.222,3.222,0,0,0,6.556,4.222V5.444H3.111A2.113,2.113,0,0,0,1,7.555V12a1,1,0,0,0,1,1H4.1a1.317,1.317,0,0,1,1.323,1.01,1.223,1.223,0,0,1-1.2,1.434H2a1,1,0,0,0-1,1v4.445A2.113,2.113,0,0,0,3.111,23ZM3,17.444H4.222A3.224,3.224,0,0,0,7.4,13.688,3.313,3.313,0,0,0,4.1,11H3V7.555a.111.111,0,0,1,.111-.111H7.556a1,1,0,0,0,1-1V4.222A1.223,1.223,0,0,1,9.99,3.017,1.316,1.316,0,0,1,11,4.34v2.1a1,1,0,0,0,1,1h4.445a.111.111,0,0,1,.111.111V12a1,1,0,0,0,1,1h2.1a1.317,1.317,0,0,1,1.324,1.01,1.225,1.225,0,0,1-1.205,1.434H17.556a1,1,0,0,0-1,1v4.445a.111.111,0,0,1-.111.111H14.111V19.778A3.222,3.222,0,0,0,10.355,16.6a3.313,3.313,0,0,0-2.688,3.3V21H3.111A.111.111,0,0,1,3,20.889Z' />
  </svg>
);

export const userSettingSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M24 4h-7v2h7v-2zm0 4h-7v2h7v-2zm0 4h-7v2h7v-2zm-4 9.193v.807h-2v-.984c0-1.329.085-1.713-1.208-2.013-2.479-.572-4.822-1.112-5.714-3.067-.333-.728-.556-1.921.266-3.473 1.646-3.109 2.075-5.746 1.179-7.235-.644-1.069-1.856-1.228-2.523-1.228-.672 0-1.896.163-2.546 1.254-.9 1.511-.464 4.132 1.194 7.191.839 1.547.622 2.744.292 3.476-.887 1.966-3.318 2.526-5.67 3.068-1.348.309-1.27.675-1.27 2.011v1h-1.996l-.004-.833c-.009-2.224.088-3.495 2.647-4.086 2.805-.647 5.573-1.227 4.242-3.682-3.943-7.275-1.123-11.399 3.111-11.399 4.154 0 7.042 3.971 3.111 11.398-1.292 2.44 1.375 3.02 4.242 3.682 2.569.594 2.657 1.873 2.647 4.113z' />
  </svg>
);

export const menuSVG = (
  <svg
    clipRule='evenodd'
    fillRule='evenodd'
    strokeLinejoin='round'
    strokeMiterlimit='2'
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='m13 16.745c0-.414-.336-.75-.75-.75h-9.5c-.414 0-.75.336-.75.75s.336.75.75.75h9.5c.414 0 .75-.336.75-.75zm9-5c0-.414-.336-.75-.75-.75h-18.5c-.414 0-.75.336-.75.75s.336.75.75.75h18.5c.414 0 .75-.336.75-.75zm-4-5c0-.414-.336-.75-.75-.75h-14.5c-.414 0-.75.336-.75.75s.336.75.75.75h14.5c.414 0 .75-.336.75-.75z'
      fillRule='nonzero'
    />
  </svg>
);
export const bellSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M15 21c0 1.598-1.392 3-2.971 3s-3.029-1.402-3.029-3h6zm.137-17.055c-.644-.374-1.042-1.07-1.041-1.82v-.003c.001-1.172-.938-2.122-2.096-2.122s-2.097.95-2.097 2.122v.003c.001.751-.396 1.446-1.041 1.82-4.668 2.709-1.985 11.715-6.862 13.306v1.749h20v-1.749c-4.877-1.591-2.193-10.598-6.863-13.306zm-3.137-2.945c.552 0 1 .449 1 1 0 .552-.448 1-1 1s-1-.448-1-1c0-.551.448-1 1-1zm-6.451 16c1.189-1.667 1.605-3.891 1.964-5.815.447-2.39.869-4.648 2.354-5.509 1.38-.801 2.956-.76 4.267 0 1.485.861 1.907 3.119 2.354 5.509.359 1.924.775 4.148 1.964 5.815h-12.903z' />
  </svg>
);
/* export const bellSVG = (
  <svg
    width='24'
    height='24'
    xmlns='http://www.w3.org/2000/svg'
    fillRule='evenodd'
    clipRule='evenodd'
  >
    <path d='M1 20v-2.946c1.993-.656 2.575-2.158 3.668-6.077.897-3.218 1.891-6.784 4.873-8.023-.027-.147-.041-.299-.041-.454 0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5c0 .156-.014.309-.042.458 2.987 1.244 3.984 4.813 4.884 8.033 1.103 3.95 1.697 5.423 3.658 6.062v2.947h-7c0 2.208-1.792 4-4 4s-4-1.792-4-4h-7zm14 0h-6c0 1.656 1.344 3 3 3s3-1.344 3-3zm-13-1h20v-1.241c-2.062-.918-2.82-3.633-3.621-6.498-1.066-3.814-2.167-7.758-6.379-7.761-4.21 0-5.308 3.937-6.369 7.745-.8 2.872-1.559 5.593-3.631 6.514v1.241zm11.492-16.345l.008-.155c0-.828-.672-1.5-1.5-1.5s-1.5.672-1.5 1.5l.008.152c.455-.099.949-.152 1.487-.152.542 0 1.039.054 1.497.155z' />
  </svg>
); */
export const sunSVG = (
  /* fill="#ffb62e" */
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M17 12c0 2.762-2.238 5-5 5s-5-2.238-5-5 2.238-5 5-5 5 2.238 5 5zm-5-7c.34 0 .672.033 1 .08v-2.08h-2v2.08c.328-.047.66-.08 1-.08zm-4.184 1.401l-1.472-1.473-1.415 1.415 1.473 1.473c.402-.537.878-1.013 1.414-1.415zm9.782 1.414l1.473-1.473-1.414-1.414-1.473 1.473c.537.402 1.012.878 1.414 1.414zm-5.598 11.185c-.34 0-.672-.033-1-.08v2.08h2v-2.08c-.328.047-.66.08-1 .08zm4.185-1.402l1.473 1.473 1.415-1.415-1.473-1.472c-.403.536-.879 1.012-1.415 1.414zm-11.185-5.598c0-.34.033-.672.08-1h-2.08v2h2.08c-.047-.328-.08-.66-.08-1zm13.92-1c.047.328.08.66.08 1s-.033.672-.08 1h2.08v-2h-2.08zm-12.519 5.184l-1.473 1.473 1.414 1.414 1.473-1.473c-.536-.402-1.012-.877-1.414-1.414z' />
  </svg>
);

export const moonSVG = (
  <svg
    width='24px'
    height='24px'
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M12 11.807A9.002 9.002 0 0 1 10.049 2a9.942 9.942 0 0 0-5.12 2.735c-3.905 3.905-3.905 10.237 0 14.142 3.906 3.906 10.237 3.905 14.143 0a9.946 9.946 0 0 0 2.735-5.119A9.003 9.003 0 0 1 12 11.807z' />
  </svg>
);

export const navigationSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M24 6h-24v-4h24v4zm0 4h-24v4h24v-4zm0 8h-24v4h24v-4z' />
  </svg>
);
export const filledCheckboxSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-1.959 17l-4.5-4.319 1.395-1.435 3.08 2.937 7.021-7.183 1.422 1.409-8.418 8.591z' />
  </svg>
);
export const userSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M12 2c2.757 0 5 2.243 5 5.001 0 2.756-2.243 5-5 5s-5-2.244-5-5c0-2.758 2.243-5.001 5-5.001zm0-2c-3.866 0-7 3.134-7 7.001 0 3.865 3.134 7 7 7s7-3.135 7-7c0-3.867-3.134-7.001-7-7.001zm6.369 13.353c-.497.498-1.057.931-1.658 1.302 2.872 1.874 4.378 5.083 4.972 7.346h-19.387c.572-2.29 2.058-5.503 4.973-7.358-.603-.374-1.162-.811-1.658-1.312-4.258 3.072-5.611 8.506-5.611 10.669h24c0-2.142-1.44-7.557-5.631-10.647z' />
  </svg>
);
export const logoutSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M16 10v-5l8 7-8 7v-5h-8v-4h8zm-16-8v20h14v-2h-12v-16h12v-2h-14z' />
  </svg>
);
export const arrowHeadLeftSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z' />
  </svg>
);
export const arrowHeadRightSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M7.33 24l-2.83-2.829 9.339-9.175-9.339-9.167 2.83-2.829 12.17 11.996z' />
  </svg>
);
export const disableSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm9 12c0 1.94-.624 3.735-1.672 5.207l-12.535-12.535c1.472-1.048 3.267-1.672 5.207-1.672 4.962 0 9 4.038 9 9zm-18 0c0-1.94.624-3.735 1.672-5.207l12.534 12.534c-1.471 1.049-3.266 1.673-5.206 1.673-4.962 0-9-4.038-9-9z' />
  </svg>
);
export const crossSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z' />
  </svg>
);
export const arrowRightThickSVG = (
  <svg
    clipRule='evenodd'
    fillRule='evenodd'
    strokeLinejoin='round'
    strokeMiterlimit='2'
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='m13.022 14.999v3.251c0 .412.335.75.752.75.188 0 .375-.071.518-.206 1.775-1.685 4.945-4.692 6.396-6.069.2-.189.312-.452.312-.725 0-.274-.112-.536-.312-.725-1.451-1.377-4.621-4.385-6.396-6.068-.143-.136-.33-.207-.518-.207-.417 0-.752.337-.752.75v3.251h-9.02c-.531 0-1.002.47-1.002 1v3.998c0 .53.471 1 1.002 1z'
      fillRule='nonzero'
    />
  </svg>
);
export const arrowRightThinSVG = (
  <svg
    clipRule='evenodd'
    fillRule='evenodd'
    strokeLinejoin='round'
    strokeMiterlimit='2'
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='m14.523 18.787s4.501-4.505 6.255-6.26c.146-.146.219-.338.219-.53s-.073-.383-.219-.53c-1.753-1.754-6.255-6.258-6.255-6.258-.144-.145-.334-.217-.524-.217-.193 0-.385.074-.532.221-.293.292-.295.766-.004 1.056l4.978 4.978h-14.692c-.414 0-.75.336-.75.75s.336.75.75.75h14.692l-4.979 4.979c-.289.289-.286.762.006 1.054.148.148.341.222.533.222.19 0 .378-.072.522-.215z'
      fillRule='nonzero'
    />
  </svg>
);
export const plusSignSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M24 10h-10v-10h-4v10h-10v4h10v10h4v-10h10z' />
  </svg>
);
export const minusSignSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M0 10h24v4h-24z' />
  </svg>
);
export const saveSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M14 3h2.997v5h-2.997v-5zm9 1v20h-22v-24h17.997l4.003 4zm-17 5h12v-7h-12v7zm14 4h-16v9h16v-9z' />
  </svg>
);
export const orderSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M16.53 7l-.564 2h-15.127l-.839-2h16.53zm-14.013 6h12.319l.564-2h-13.722l.839 2zm5.983 5c-.828 0-1.5.672-1.5 1.5 0 .829.672 1.5 1.5 1.5s1.5-.671 1.5-1.5c0-.828-.672-1.5-1.5-1.5zm11.305-15l-3.432 12h-13.017l.839 2h13.659l3.474-12h1.929l.743-2h-4.195zm-6.305 15c-.828 0-1.5.671-1.5 1.5s.672 1.5 1.5 1.5 1.5-.671 1.5-1.5c0-.828-.672-1.5-1.5-1.5z' />
  </svg>
);
export const shopSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M10 9v-1.098l1.047-4.902h1.905l1.048 4.9v1.098c0 1.067-.933 2.002-2 2.002s-2-.933-2-2zm5 0c0 1.067.934 2 2.001 2s1.999-.833 1.999-1.9v-1.098l-2.996-5.002h-1.943l.939 4.902v1.098zm-10 .068c0 1.067.933 1.932 2 1.932s2-.865 2-1.932v-1.097l.939-4.971h-1.943l-2.996 4.971v1.097zm-4 2.932h22v12h-22v-12zm2 8h18v-6h-18v6zm1-10.932v-1.097l2.887-4.971h-2.014l-4.873 4.971v1.098c0 1.066.933 1.931 2 1.931s2-.865 2-1.932zm15.127-6.068h-2.014l2.887 4.902v1.098c0 1.067.933 2 2 2s2-.865 2-1.932v-1.097l-4.873-4.971zm-.127-3h-14v2h14v-2z' />
  </svg>
);
export const agencySVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fillRule='evenodd'
    clipRule='evenodd'
  >
    <path d='M12 2h2v2h2v3.702l7 2.618v12.68h1v1h-24v-1h1v-11h6v-8h2v-2h2v-2h1v2zm3 3h-7v18h1v-2h5v2h1v-18zm-2 17h-3v1h3v-1zm8 1h1v-11.987l-6-2.243v14.23h1v-2h4v2zm-14-10h-5v10h1v-2h3v2h1v-10zm-2 9h-1v1h1v-1zm15 0h-2v1h2v-1zm-16-5v2h-1v-2h1zm2 0v2h-1v-2h1zm5-10v12h-1v-12h1zm10 11v1h-4v-1h4zm-8-11v12h-1v-12h1zm8 9v1h-4v-1h4zm-17-2v2h-1v-2h1zm2 0v2h-1v-2h1zm15 0v1h-4v-1h4zm0-2v1h-4v-1h4zm-8-9h-3v1h3v-1z' />
  </svg>
);
export const switchShopSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M21.49 13.926l-3.273 2.48c.054-.663.116-1.435.143-2.275.04-.89.023-1.854-.043-2.835-.043-.487-.097-.98-.184-1.467-.077-.485-.196-.982-.31-1.39-.238-.862-.535-1.68-.9-2.35-.352-.673-.786-1.173-1.12-1.462-.172-.144-.31-.248-.414-.306l-.153-.093c-.083-.05-.187-.056-.275-.003-.13.08-.175.252-.1.388l.01.02s.11.198.258.54c.07.176.155.38.223.63.08.24.14.528.206.838.063.313.114.66.17 1.03l.15 1.188c.055.44.106.826.13 1.246.03.416.033.85.026 1.285.004.872-.063 1.76-.115 2.602-.062.853-.12 1.65-.172 2.335 0 .04-.004.073-.005.11l-.115-.118-2.996-3.028-1.6.454 5.566 6.66 6.394-5.803-1.503-.677z' />
    <path d='M2.503 9.48L5.775 7c-.054.664-.116 1.435-.143 2.276-.04.89-.023 1.855.043 2.835.043.49.097.98.184 1.47.076.484.195.98.31 1.388.237.862.534 1.68.9 2.35.35.674.785 1.174 1.12 1.463.17.145.31.25.413.307.1.06.152.093.152.093.083.05.187.055.275.003.13-.08.175-.252.1-.388l-.01-.02s-.11-.2-.258-.54c-.07-.177-.155-.38-.223-.63-.082-.242-.14-.528-.207-.84-.064-.312-.115-.658-.172-1.027-.046-.378-.096-.777-.15-1.19-.053-.44-.104-.825-.128-1.246-.03-.415-.033-.85-.026-1.285-.004-.872.063-1.76.115-2.603.064-.853.122-1.65.174-2.334 0-.04.004-.074.005-.11l.114.118 2.996 3.027 1.6-.454L7.394 3 1 8.804l1.503.678z' />
  </svg>
);
export const imageSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M14 9l-2.519 4-2.481-1.96-5 6.96h16l-6-9zm8-5v16h-20v-16h20zm2-2h-24v20h24v-20zm-20 6c0-1.104.896-2 2-2s2 .896 2 2c0 1.105-.896 2-2 2s-2-.895-2-2z' />
  </svg>
);
export const editSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M1.439 16.873l-1.439 7.127 7.128-1.437 16.873-16.872-5.69-5.69-16.872 16.872zm4.702 3.848l-3.582.724.721-3.584 2.861 2.86zm15.031-15.032l-13.617 13.618-2.86-2.861 10.825-10.826 2.846 2.846 1.414-1.414-2.846-2.846 1.377-1.377 2.861 2.86z' />
  </svg>
);
export const infoSVG = (
  <svg
    clipRule='evenodd'
    fillRule='evenodd'
    strokeLinejoin='round'
    strokeMiterlimit='2'
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='m12.002 2.005c5.518 0 9.998 4.48 9.998 9.997 0 5.518-4.48 9.998-9.998 9.998-5.517 0-9.997-4.48-9.997-9.998 0-5.517 4.48-9.997 9.997-9.997zm0 1.5c-4.69 0-8.497 3.807-8.497 8.497s3.807 8.498 8.497 8.498 8.498-3.808 8.498-8.498-3.808-8.497-8.498-8.497zm0 6.5c-.414 0-.75.336-.75.75v5.5c0 .414.336.75.75.75s.75-.336.75-.75v-5.5c0-.414-.336-.75-.75-.75zm-.002-3c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1z'
      fillRule='nonzero'
    />
  </svg>
);
export const eyeSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M12.015 7c4.751 0 8.063 3.012 9.504 4.636-1.401 1.837-4.713 5.364-9.504 5.364-4.42 0-7.93-3.536-9.478-5.407 1.493-1.647 4.817-4.593 9.478-4.593zm0-2c-7.569 0-12.015 6.551-12.015 6.551s4.835 7.449 12.015 7.449c7.733 0 11.985-7.449 11.985-7.449s-4.291-6.551-11.985-6.551zm-.015 3c-2.209 0-4 1.792-4 4 0 2.209 1.791 4 4 4s4-1.791 4-4c0-2.208-1.791-4-4-4z' />
  </svg>
);
export const eyeCrossedSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M19.604 2.562l-3.346 3.137c-1.27-.428-2.686-.699-4.243-.699-7.569 0-12.015 6.551-12.015 6.551s1.928 2.951 5.146 5.138l-2.911 2.909 1.414 1.414 17.37-17.035-1.415-1.415zm-6.016 5.779c-3.288-1.453-6.681 1.908-5.265 5.206l-1.726 1.707c-1.814-1.16-3.225-2.65-4.06-3.66 1.493-1.648 4.817-4.594 9.478-4.594.927 0 1.796.119 2.61.315l-1.037 1.026zm-2.883 7.431l5.09-4.993c1.017 3.111-2.003 6.067-5.09 4.993zm13.295-4.221s-4.252 7.449-11.985 7.449c-1.379 0-2.662-.291-3.851-.737l1.614-1.583c.715.193 1.458.32 2.237.32 4.791 0 8.104-3.527 9.504-5.364-.729-.822-1.956-1.99-3.587-2.952l1.489-1.46c2.982 1.9 4.579 4.327 4.579 4.327z' />
  </svg>
);
export const trashSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M17.573 1.848c.083.699-.476 1.152-1.182 1.152h-8.774c-.704 0-1.266-.452-1.182-1.156-1.329.281-4.435 1.159-4.435 2.516 0 .303.103.7.235 1.361 3.175 2.953 15.758 3.088 19.476.244.159-.824.289-1.278.289-1.611 0-1.333-3.091-2.223-4.427-2.506zm3.113 6.897c-.868 4.587-2.184 10.54-2.709 13.287-1.079 1.312-3.545 1.968-6.013 1.968s-4.935-.656-6.013-1.968c-.529-2.884-1.834-8.868-2.684-13.414.679.274 1.408.492 2.149.67 0 0 2.132 10.441 2.382 11.747.722.514 2.237.965 4.166.965 1.933 0 3.452-.454 4.17-.969.224-1.131 2.411-11.661 2.411-11.661.733-.165 1.46-.367 2.141-.625zm-13.069-6.763c.922 0 1.669-1.08 1.669-1.982h5.437c0 .902.747 1.982 1.668 1.982h-8.774z' />
  </svg>
);
export const copySVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M18 6v-6h-18v18h6v6h18v-18h-6zm-12 10h-4v-14h14v4h-10v10zm16 6h-14v-14h14v14z' />
  </svg>
);

export const webShopSVG = (
  <svg
    id='Layer_1'
    data-name='Layer 1'
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 121.09 122.88'
  >
    <path d='M4,24.8a4.05,4.05,0,0,1,0-8.1H9.94a19,19,0,0,1,9.75,2.57C25.05,22.67,26,27.52,27.38,33h4.19v.51a41.08,41.08,0,0,0,.7,7.49H29.63l9.13,30.3h64.69L112,41h-.66a41.08,41.08,0,0,0,.69-7.49V33h5.1a4,4,0,0,1,4,4,5.26,5.26,0,0,1-.2,1.23L110.43,76.33a4,4,0,0,1-3.9,3.08H40.91c1.44,5.33,2.87,8.2,4.82,9.53,2.36,1.54,6.46,1.64,13.33,1.54h46.45a4,4,0,0,1,0,8H59.16c-8.51.1-13.74-.11-17.94-2.87s-6.57-7.8-8.82-16.72h0L18.66,31c0-.11,0-.11-.1-.21a7.15,7.15,0,0,0-3.08-4.61A10.36,10.36,0,0,0,9.84,24.8H4ZM95.78,51.86H87.11a51.6,51.6,0,0,1-4.87,6,73.19,73.19,0,0,1-5.79,5.48l.35-.06c.35-.05.71-.12,1.07-.19h0c1-.2,1.93-.44,2.87-.73a25.05,25.05,0,0,0,2.78-1c.93-.4,1.82-.83,2.68-1.29s1.7-1,2.5-1.51A27.55,27.55,0,0,0,91,56.78c.74-.6,1.44-1.25,2.13-1.93.53-.53,1-1.07,1.51-1.63s.76-.9,1.12-1.36ZM42.09,41.25,38.62,25.78h5l1.59,9.43h.11l1.77-9.43h4.85l1.84,9.35h.11l1.52-9.35h5L56.91,41.25H51.53l-2-8.3h-.14l-2,8.3Zm22.28,0L60.9,25.78h5l1.59,9.43h.1l1.78-9.43H74.2l1.85,9.35h.1l1.52-9.35h5L79.19,41.25H73.8l-2-8.3h-.14l-2,8.3Zm22.27,0L83.17,25.78h5l1.59,9.43h.11l1.77-9.43h4.85l1.84,9.35h.11L100,25.78h5l-3.47,15.47H96.08l-2-8.3H94l-2,8.3Zm-19.52,22a73,73,0,0,1-5.78-5.48,51.72,51.72,0,0,1-4.88-6H47.82c.36.46.73.92,1.11,1.36s1,1.1,1.52,1.63c.69.69,1.4,1.33,2.13,1.93a26,26,0,0,0,2.31,1.71c.79.54,1.62,1,2.48,1.51s1.76.89,2.69,1.29l.06,0,0,0c.9.37,1.8.71,2.73,1a27,27,0,0,0,2.85.72c.36.07.72.14,1.07.19l.32.06ZM47.79,15.18H57a59.19,59.19,0,0,1,4.79-5.95c1.68-1.84,3.56-3.69,5.62-5.55l-.48.07c-.4.06-.79.13-1.18.21h0c-1,.2-1.93.44-2.88.73a28,28,0,0,0-2.77,1c-.93.4-1.82.83-2.68,1.3a27.1,27.1,0,0,0-2.5,1.5c-.81.54-1.57,1.11-2.31,1.71a27.81,27.81,0,0,0-2.13,1.94c-.53.52-1,1.06-1.52,1.62s-.76.91-1.12,1.39ZM76.22,3.7c2.06,1.85,3.93,3.7,5.6,5.53a59,59,0,0,1,4.78,5.95h9.16c-.36-.47-.73-.93-1.12-1.37s-1-1.09-1.51-1.62c-.69-.69-1.4-1.34-2.13-1.94a27.55,27.55,0,0,0-2.31-1.71A26.77,26.77,0,0,0,86.21,7c-.87-.47-1.76-.9-2.7-1.3,0,0,0,0-.05,0l0,0q-1.35-.56-2.73-1A27,27,0,0,0,77.85,4h0q-.58-.12-1.17-.21l-.44-.07ZM65,.66A32.76,32.76,0,0,1,68.36.17C69.48.06,70.63,0,71.78,0s2.29.06,3.41.17a33.18,33.18,0,0,1,3.32.49,31.46,31.46,0,0,1,3.18.8,32.23,32.23,0,0,1,3.06,1.13l.07,0,.06,0c1,.42,1.94.89,2.87,1.39h0q1.44.78,2.79,1.68A32.23,32.23,0,0,1,95.5,9.79h0a31.85,31.85,0,0,1,2.14,2.36c.68.83,1.31,1.69,1.91,2.58a32.29,32.29,0,0,1,1.67,2.77c.16.3.32.6.47.9H41.85l.47-.91c.52-.95,1.08-1.87,1.67-2.76s1.22-1.73,1.89-2.55,1.42-1.64,2.17-2.4h0a31.84,31.84,0,0,1,2.35-2.15C51.25,7,52.11,6.32,53,5.73s1.82-1.16,2.77-1.68,1.94-1,2.94-1.42a31.51,31.51,0,0,1,3.12-1.15C62.89,1.16,64,.89,65,.66Zm36.67,48c-.15.31-.31.61-.48.91-.52.95-1.07,1.87-1.66,2.76a30,30,0,0,1-1.89,2.55c-.69.84-1.42,1.64-2.18,2.4h0a29.78,29.78,0,0,1-2.35,2.15,31.69,31.69,0,0,1-2.58,1.9c-.9.61-1.82,1.16-2.77,1.68s-1.94,1-2.94,1.42a33,33,0,0,1-9.65,2.47c-1.13.11-2.27.16-3.42.16s-2.29,0-3.41-.16a33.2,33.2,0,0,1-3.32-.5,31.46,31.46,0,0,1-3.18-.8,32.15,32.15,0,0,1-3.06-1.12l-.07,0-.06,0c-1-.43-1.94-.89-2.87-1.4S53.91,61.9,53,61.3a31,31,0,0,1-2.55-1.88c-.84-.69-1.64-1.42-2.4-2.18h0a29.78,29.78,0,0,1-2.14-2.36A30,30,0,0,1,44,52.3c-.6-.9-1.16-1.82-1.67-2.78-.17-.29-.32-.59-.47-.9h59.86ZM73.46,5.75v9.43h9a59.55,59.55,0,0,0-4-4.67c-1.5-1.58-3.15-3.16-5-4.76Zm0,46.11v9.56c1.91-1.59,3.66-3.18,5.25-4.79a54.88,54.88,0,0,0,4.23-4.77ZM70.1,61.42V51.86H60.61a54.71,54.71,0,0,0,4.22,4.77c1.59,1.6,3.34,3.2,5.27,4.79Zm0-46.24V5.75c-1.81,1.6-3.46,3.18-5,4.76a61.54,61.54,0,0,0-4,4.67Zm23.41,88A9.85,9.85,0,1,1,83.67,113a9.85,9.85,0,0,1,9.84-9.85Zm-43.17,0A9.85,9.85,0,1,1,40.5,113a9.85,9.85,0,0,1,9.84-9.85Z' />
  </svg>
);
export const clockSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm5.848 12.459c.202.038.202.333.001.372-1.907.361-6.045 1.111-6.547 1.111-.719 0-1.301-.582-1.301-1.301 0-.512.77-5.447 1.125-7.445.034-.192.312-.181.343.014l.985 6.238 5.394 1.011z' />
  </svg>
);
export const aiGenerateSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    stroke='var(--main-text-color)'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <path d='M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z'></path>
    <path d='M20 3v4'></path>
    <path d='M22 5h-4'></path>
    <path d='M4 17v2'></path>
    <path d='M5 18H3'></path>
  </svg>
);

export const UnlockPaymentSVG = (
  <svg
    version='1.1'
    viewBox='0 0 2048 2048'
    width='1280'
    height='1280'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      transform='translate(333,205)'
      d='m0 0h1383l17 3 16 5 12 5 16 9 14 11 14 14 11 15 8 14 8 21 3 12 2 17v905l-3 21-5 16-5 12-8 15-9 12-11 12-10 9-15 10-11 6-1 410-3 16-6 16-8 13-9 11-10 9-11 7-13 6-13 4-12 2h-599l-17-3-14-5-14-8-13-11-9-10-9-15-5-12-3-12-1-7-1-164v-233l-653-1-20-3-16-5-12-5-10-5-12-8-14-12-12-13-10-14-8-16-6-15-4-19-2-25v-855l1-41 3-17 5-17 9-19 9-13 8-10 5-6 8-7 13-10 16-9 14-6 14-4zm4 68-13 3-14 7-10 8-9 10-8 15-4 16v904l4 15 7 13 8 10 8 7 14 8 13 4 7 1h649l5-25 6-16 8-13 6-7v-2h2l5-5 9-8 12-7 13-5 20-4 17-1 1-7v-138l1-46 4-31 6-25 9-27 11-24 10-18 8-12 10-14 11-13 9-10 16-16 14-11 15-11 21-13 17-9 25-10 26-8 26-5 16-2 14-1h25l30 3 25 5 24 7 21 8 17 8 19 11 19 13 16 13 12 11 15 15 9 11 14 19 12 20 10 19 11 28 7 25 5 26 2 19v27l-4 10-6 8-10 6-8 2h-11l-11-4-8-7-5-7-3-11-2-28-4-24-5-18-8-20-8-17-12-19-10-13-12-14-7-7-11-9-17-13-15-9-16-8-20-8-26-7-21-3-22-1-20 1-25 4-21 6-18 7-16 8-17 10-17 13-10 9-4 3v2l-4 2-7 8-10 12-12 18-10 18-8 19-6 18-5 24-2 22v180l5 1h505l15 2 16 5 13 7 13 10 7 7 8 11 7 12 4 10 4-2 6-12 4-14 1-10v-892l-2-13-5-13-7-11-9-10-10-7-13-6-13-3zm744 996-10 3-9 8-3 6-1 5v464l4 9 7 7 7 3 5 1h586l9-2 6-4 6-7 2-5 1-7v-459l-3-9-7-8-7-4-7-1z'
    />
    <path
      transform='translate(575,403)'
      d='m0 0h15l20 2 19 4 24 8 18-7 22-5 18-2h20l24 3 19 5 18 7 19 10 14 10 13 11 13 13 10 13 10 16 8 16 7 19 4 17 3 26v12l-3 26-5 20-7 19-10 19-12 17-10 11-6 7-8 7-13 10-15 9-16 8-24 8-20 4-9 1h-29l-20-3-21-6-10-4h-6l-17 6-21 5-16 2h-28l-24-4-17-5-21-9-16-9-16-12-16-15-9-10-13-19-11-21-8-24-4-19-1-9v-31l3-20 5-19 10-24 10-17 13-17 12-13 10-9 19-13 23-12 24-8 21-4zm3 68-21 3-15 5-15 8-13 10-11 11-11 16-7 15-4 14-2 11v22l3 16 6 17 8 14 8 10 8 9 13 10 19 10 16 5 12 2h21l19-4 16-6 14-8 11-9 10-10 9-13 8-16 4-13 2-10 1-10v-9l-2-16-3-12-7-16-7-12-11-13-11-10-13-8-12-6-17-5-13-2zm142 0 2 5 9 14 8 15 8 21 5 22 2 18v19l-2 18-5 21-7 19-12 23-8 12v1l19-1 18-5 16-8 13-9 10-9 8-9 9-15 5-11 4-13 2-11v-26l-4-18-6-15-7-12-7-9-9-10-13-10-10-6-15-6-11-3-16-2z'
    />
    <path
      transform='translate(1368,1380)'
      d='m0 0h13l17 2 20 6 19 10 13 10 13 13 9 13 9 17 6 19 2 13v25l-4 19-6 16-7 13-8 11-11 12-10 8-13 8-12 6-9 4v57l-2 12-5 9-8 8-9 4-4 1h-15l-9-4-8-6-6-10-2-5-1-6v-61l-9-3-16-8-10-7-11-9-10-11-7-10-6-11-6-14-4-16-1-6v-27l4-20 8-20 9-14 8-10 12-12 13-9 17-9 20-6zm-4 69-12 5-8 6-5 5-7 10-3 9-1 6v11l3 12 6 10 5 6 10 7 9 4 4 1h19l13-5 8-6 5-5 4-5 4-8 3-12v-11l-3-11-6-11-7-8-10-6-11-4z'
    />
    <path
      transform='translate(1217,451)'
      d='m0 0h387l10 2 10 5 8 9 4 9 1 4v11l-4 11-6 8-8 6-9 3-12 1h-374l-16-2-8-4-7-6-6-11-2-7v-10l4-11 6-8 11-7 5-2z'
    />
    <path
      transform='translate(1213,597)'
      d='m0 0h206l9 4 8 6 6 9 3 8v13l-4 11-6 8-9 6-6 2-7 1h-198l-10-3-9-6-6-7-4-9-1-4v-10l3-10 4-6 7-7 10-5z'
    />
  </svg>
);

export const shopifySVG = (
  <svg
    width='2192'
    height='2500'
    viewBox='0 0 256 292'
    xmlns='http://www.w3.org/2000/svg'
    preserveAspectRatio='xMidYMid'
  >
    <path d='M223.774 57.34c-.201-1.46-1.48-2.268-2.537-2.357-1.055-.088-23.383-1.743-23.383-1.743s-15.507-15.395-17.209-17.099c-1.703-1.703-5.029-1.185-6.32-.805-.19.056-3.388 1.043-8.678 2.68-5.18-14.906-14.322-28.604-30.405-28.604-.444 0-.901.018-1.358.044C129.31 3.407 123.644.779 118.75.779c-37.465 0-55.364 46.835-60.976 70.635-14.558 4.511-24.9 7.718-26.221 8.133-8.126 2.549-8.383 2.805-9.45 10.462C21.3 95.806.038 260.235.038 260.235l165.678 31.042 89.77-19.42S223.973 58.8 223.775 57.34zM156.49 40.848l-14.019 4.339c.005-.988.01-1.96.01-3.023 0-9.264-1.286-16.723-3.349-22.636 8.287 1.04 13.806 10.469 17.358 21.32zm-27.638-19.483c2.304 5.773 3.802 14.058 3.802 25.238 0 .572-.005 1.095-.01 1.624-9.117 2.824-19.024 5.89-28.953 8.966 5.575-21.516 16.025-31.908 25.161-35.828zm-11.131-10.537c1.617 0 3.246.549 4.805 1.622-12.007 5.65-24.877 19.88-30.312 48.297l-22.886 7.088C75.694 46.16 90.81 10.828 117.72 10.828z' />
    <path d='M221.237 54.983c-1.055-.088-23.383-1.743-23.383-1.743s-15.507-15.395-17.209-17.099c-.637-.634-1.496-.959-2.394-1.099l-12.527 256.233 89.762-19.418S223.972 58.8 223.774 57.34c-.201-1.46-1.48-2.268-2.537-2.357' />
    <path
      d='M135.242 104.585l-11.069 32.926s-9.698-5.176-21.586-5.176c-17.428 0-18.305 10.937-18.305 13.693 0 15.038 39.2 20.8 39.2 56.024 0 27.713-17.577 45.558-41.277 45.558-28.44 0-42.984-17.7-42.984-17.7l7.615-25.16s14.95 12.835 27.565 12.835c8.243 0 11.596-6.49 11.596-11.232 0-19.616-32.16-20.491-32.16-52.724 0-27.129 19.472-53.382 58.778-53.382 15.145 0 22.627 4.338 22.627 4.338'
      fill='#FFF'
    />
  </svg>
);

export const IntegrationSVG = (
  <svg
    version='1.1'
    id='Layer_1'
    xmlns='http://www.w3.org/2000/svg'
    x='0px'
    y='0px'
    viewBox='0 0 122.88 122.46'
  >
    <g>
      <path
        className='st0'
        d='M69.76,26.16l-7.75,7.75L54.02,42L42.21,53.81l-8.09,7.99l-7.54,7.54c-1.4,1.4-3.68,1.4-5.08,0l-2.95-2.95 c-1.4-1.4-1.4-3.68,0-5.08l43.18-43.18c1.4-1.4,3.68-1.4,5.08,0l2.95,2.95C71.16,22.48,71.16,24.76,69.76,26.16L69.76,26.16z M48.35,26.93L26.93,48.36l-3.18-3.18l21.42-21.42L48.35,26.93L48.35,26.93z M53.12,96.3l7.75-7.75L45.28,72.96 c-2.21-2.21-2.21-5.83,0-8.04l0,0c2.21-2.21,5.83-2.21,8.04,0l15.54,15.54l11.81-11.81L65.13,53.11c-2.21-2.21-2.21-5.83,0-8.04 l0,0c2.21-2.21,5.83-2.21,8.04,0l15.59,15.59l7.54-7.54c1.4-1.4,3.68-1.4,5.08,0l2.95,2.95c1.4,1.4,1.4,3.68,0,5.08l-43.18,43.18 c-1.4,1.4-3.68,1.4-5.08,0l-2.95-2.95C51.72,99.99,51.72,97.7,53.12,96.3L53.12,96.3z M74.48,95.48L95.9,74.06l3.18,3.18 L77.66,98.66L74.48,95.48L74.48,95.48z M63.14,102.33l6.2,6.21c10.79,10.79,20.86,11.28,33.18,1.61l12.31,12.31l8.04-8.04 l-12.41-12.41c9.83-11.93,8.34-23.24-2.11-33.69l-5.6-5.6L63.14,102.33L63.14,102.33z M59.74,20.13l-6.2-6.21 C42.75,3.13,32.67,2.64,20.36,12.31L8.04,0L0,8.04l12.41,12.41c-9.83,11.93-8.34,23.24,2.11,33.69l5.6,5.6L59.74,20.13L59.74,20.13 z'
      />
    </g>
  </svg>
);
export const RecommendationsSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 26 26'
    width='26px'
    height='26px'
  >
    <path d='M 12.90625 -0.03125 C 12.863281 -0.0234375 12.820313 -0.0117188 12.78125 0 C 12.316406 0.105469 11.988281 0.523438 12 1 L 12 4 C 11.996094 4.359375 12.183594 4.695313 12.496094 4.878906 C 12.808594 5.058594 13.191406 5.058594 13.503906 4.878906 C 13.816406 4.695313 14.003906 4.359375 14 4 L 14 1 C 14.011719 0.710938 13.894531 0.433594 13.6875 0.238281 C 13.476563 0.0390625 13.191406 -0.0585938 12.90625 -0.03125 Z M 4.3125 3.5 C 3.9375 3.566406 3.636719 3.839844 3.53125 4.203125 C 3.425781 4.570313 3.535156 4.960938 3.8125 5.21875 L 5.9375 7.34375 C 6.179688 7.640625 6.566406 7.777344 6.941406 7.691406 C 7.3125 7.605469 7.605469 7.3125 7.691406 6.941406 C 7.777344 6.566406 7.640625 6.179688 7.34375 5.9375 L 5.21875 3.8125 C 5.011719 3.589844 4.710938 3.476563 4.40625 3.5 C 4.375 3.5 4.34375 3.5 4.3125 3.5 Z M 21.375 3.5 C 21.148438 3.53125 20.9375 3.644531 20.78125 3.8125 L 18.65625 5.9375 C 18.359375 6.179688 18.222656 6.566406 18.308594 6.941406 C 18.394531 7.3125 18.6875 7.605469 19.058594 7.691406 C 19.433594 7.777344 19.820313 7.640625 20.0625 7.34375 L 22.1875 5.21875 C 22.5 4.921875 22.589844 4.457031 22.40625 4.066406 C 22.21875 3.671875 21.804688 3.445313 21.375 3.5 Z M 13 7.125 C 9.789063 7.125 7.1875 9.726563 7.1875 12.9375 C 7.1875 16.234375 10.03125 18.152344 10.03125 19.84375 L 10.03125 20.25 C 10.03125 20.660156 10.375 21 10.78125 21 L 15.21875 21 C 15.625 21 15.96875 20.660156 15.96875 20.25 L 15.96875 19.84375 C 15.96875 18.148438 18.8125 16.289063 18.8125 12.9375 C 18.8125 9.726563 16.210938 7.125 13 7.125 Z M 13 9.0625 C 13.734375 9.0625 14.417969 9.269531 15 9.625 C 14.929688 9.621094 14.851563 9.59375 14.78125 9.59375 C 12.050781 9.59375 9.84375 11.804688 9.84375 14.5 C 9.84375 14.667969 9.859375 14.835938 9.875 15 C 9.4375 14.386719 9.15625 13.617188 9.15625 12.8125 C 9.15625 10.730469 10.886719 9.0625 13 9.0625 Z M 0.71875 12 C 0.167969 12.078125 -0.21875 12.589844 -0.140625 13.140625 C -0.0625 13.691406 0.449219 14.078125 1 14 L 4 14 C 4.359375 14.003906 4.695313 13.816406 4.878906 13.503906 C 5.058594 13.191406 5.058594 12.808594 4.878906 12.496094 C 4.695313 12.183594 4.359375 11.996094 4 12 L 1 12 C 0.96875 12 0.9375 12 0.90625 12 C 0.875 12 0.84375 12 0.8125 12 C 0.78125 12 0.75 12 0.71875 12 Z M 21.71875 12 C 21.167969 12.078125 20.78125 12.589844 20.859375 13.140625 C 20.9375 13.691406 21.449219 14.078125 22 14 L 25 14 C 25.359375 14.003906 25.695313 13.816406 25.878906 13.503906 C 26.058594 13.191406 26.058594 12.808594 25.878906 12.496094 C 25.695313 12.183594 25.359375 11.996094 25 12 L 22 12 C 21.96875 12 21.9375 12 21.90625 12 C 21.875 12 21.84375 12 21.8125 12 C 21.78125 12 21.75 12 21.71875 12 Z M 6.53125 18.34375 C 6.304688 18.375 6.09375 18.488281 5.9375 18.65625 L 3.8125 20.78125 C 3.515625 21.023438 3.378906 21.410156 3.464844 21.785156 C 3.550781 22.15625 3.84375 22.449219 4.214844 22.535156 C 4.589844 22.621094 4.976563 22.484375 5.21875 22.1875 L 7.34375 20.0625 C 7.640625 19.777344 7.730469 19.335938 7.570313 18.957031 C 7.414063 18.578125 7.035156 18.335938 6.625 18.34375 C 6.59375 18.34375 6.5625 18.34375 6.53125 18.34375 Z M 19.15625 18.34375 C 18.78125 18.410156 18.480469 18.683594 18.375 19.046875 C 18.269531 19.414063 18.378906 19.804688 18.65625 20.0625 L 20.78125 22.1875 C 21.023438 22.484375 21.410156 22.621094 21.785156 22.535156 C 22.15625 22.449219 22.449219 22.15625 22.535156 21.785156 C 22.621094 21.410156 22.484375 21.023438 22.1875 20.78125 L 20.0625 18.65625 C 19.875 18.457031 19.617188 18.347656 19.34375 18.34375 C 19.3125 18.34375 19.28125 18.34375 19.25 18.34375 C 19.21875 18.34375 19.1875 18.34375 19.15625 18.34375 Z M 10.75 22 C 10.339844 22 10 22.335938 10 22.75 L 10 24.25 C 10 24.664063 10.339844 25 10.75 25 L 11.375 25 C 11.703125 25.574219 12.292969 25.96875 13 25.96875 C 13.707031 25.96875 14.296875 25.574219 14.625 25 L 15.25 25 C 15.660156 25 16 24.664063 16 24.25 L 16 22.75 C 16 22.335938 15.660156 22 15.25 22 Z' />
  </svg>
);

export const settingsPlusSVG = (
  <svg
    version='1.1'
    id='Layer_1'
    xmlns='http://www.w3.org/2000/svg'
    x='0px'
    y='0px'
    width='122.88px'
    height='95.089px'
    viewBox='0 0 122.88 95.089'
    enableBackground='new 0 0 122.88 95.089'
  >
    <g>
      <path d='M66.605,9.676c-0.791-0.791-1.718-1.181-2.792-1.181c-1.073,0-2.013,0.39-2.791,1.181l-4.255,4.241 c-1.141-0.738-2.348-1.383-3.61-1.96c-1.261-0.577-2.55-1.072-3.852-1.502V3.931c0-1.1-0.375-2.026-1.141-2.791 C47.401,0.375,46.475,0,45.374,0h-8.187c-1.047,0-1.958,0.375-2.75,1.14c-0.778,0.765-1.168,1.691-1.168,2.791v5.973 c-1.368,0.321-2.697,0.724-3.973,1.221c-1.287,0.496-2.508,1.061-3.663,1.691l-4.711-4.644c-0.738-0.778-1.637-1.181-2.724-1.181 c-1.075,0-2,0.403-2.792,1.181l-5.73,5.745c-0.791,0.791-1.181,1.718-1.181,2.79c0,1.074,0.39,2.014,1.181,2.792l4.242,4.255 c-0.738,1.14-1.382,2.348-1.959,3.608c-0.578,1.262-1.073,2.552-1.504,3.853H3.933c-1.102,0-2.028,0.375-2.792,1.14 C0.376,33.121,0,34.047,0,35.148v8.187c0,1.045,0.376,1.959,1.14,2.751c0.764,0.777,1.691,1.167,2.792,1.167h5.971 c0.322,1.367,0.724,2.696,1.222,3.971c0.498,1.289,1.061,2.537,1.691,3.744l-4.644,4.63c-0.779,0.739-1.181,1.638-1.181,2.726 c0,1.073,0.402,2,1.181,2.792l5.745,5.811c0.791,0.738,1.717,1.102,2.792,1.102c1.072,0,2.011-0.363,2.791-1.102l4.254-4.321 c1.14,0.737,2.349,1.381,3.61,1.96c1.262,0.575,2.55,1.073,3.852,1.502v6.523c0,1.1,0.376,2.025,1.14,2.789 c0.765,0.767,1.692,1.143,2.792,1.143h8.186c1.047,0,1.959-0.376,2.751-1.143c0.777-0.764,1.167-1.689,1.167-2.789v-5.973 c1.369-0.321,2.697-0.724,3.972-1.222c1.289-0.496,2.538-1.061,3.744-1.691l4.63,4.645c0.739,0.778,1.65,1.181,2.753,1.181 c1.112,0,2.025-0.402,2.765-1.181l5.811-5.744c0.738-0.793,1.102-1.719,1.102-2.792s-0.363-2.013-1.102-2.791l-4.321-4.255 c0.738-1.141,1.382-2.348,1.96-3.609c0.575-1.261,1.072-2.551,1.502-3.852h6.523c1.1,0,2.025-0.378,2.789-1.141 c0.766-0.766,1.142-1.691,1.142-2.792v-8.186c0-1.047-0.376-1.958-1.142-2.752c-0.764-0.778-1.689-1.167-2.789-1.167h-5.973 c-0.322-1.315-0.725-2.63-1.222-3.931c-0.496-1.316-1.061-2.55-1.691-3.706l4.645-4.709c0.778-0.738,1.181-1.638,1.181-2.724 c0-1.075-0.402-2-1.181-2.792L66.605,9.676L66.605,9.676z M111.918,53.649c-0.506-0.355-1.044-0.479-1.627-0.376 c-0.583,0.101-1.057,0.401-1.401,0.904l-1.908,2.702c-0.688-0.292-1.402-0.526-2.144-0.721c-0.737-0.194-1.484-0.343-2.231-0.451 l-0.616-3.538c-0.105-0.596-0.395-1.063-0.884-1.406c-0.486-0.343-1.024-0.459-1.621-0.354l-4.441,0.774 c-0.566,0.099-1.025,0.39-1.383,0.879c-0.35,0.487-0.475,1.027-0.369,1.625l0.564,3.238c-0.713,0.303-1.395,0.648-2.037,1.038 c-0.654,0.392-1.263,0.812-1.828,1.264l-2.995-2.073c-0.476-0.352-0.999-0.484-1.59-0.383c-0.583,0.103-1.046,0.407-1.402,0.904 l-2.564,3.659c-0.354,0.504-0.479,1.044-0.377,1.623c0.102,0.585,0.402,1.057,0.905,1.404l2.703,1.907 c-0.292,0.687-0.527,1.402-0.721,2.144c-0.195,0.738-0.343,1.484-0.452,2.231l-3.538,0.616c-0.596,0.104-1.063,0.396-1.406,0.884 c-0.344,0.486-0.458,1.025-0.354,1.621l0.773,4.441c0.099,0.566,0.388,1.026,0.88,1.383c0.487,0.35,1.027,0.474,1.624,0.369 l3.239-0.564c0.304,0.713,0.648,1.394,1.038,2.039c0.392,0.652,0.815,1.274,1.272,1.869l-2.081,2.952 c-0.353,0.475-0.485,0.999-0.383,1.59c0.102,0.583,0.406,1.047,0.904,1.402l3.665,2.607c0.499,0.325,1.036,0.436,1.618,0.334 c0.583-0.101,1.059-0.389,1.41-0.862l1.899-2.746c0.688,0.293,1.403,0.528,2.144,0.721c0.738,0.194,1.484,0.343,2.23,0.45 l0.618,3.54c0.104,0.597,0.396,1.063,0.883,1.404c0.486,0.344,1.025,0.46,1.621,0.356l4.439-0.775 c0.569-0.1,1.028-0.389,1.386-0.879c0.349-0.488,0.474-1.025,0.368-1.624l-0.565-3.241c0.713-0.303,1.396-0.646,2.04-1.037 c0.651-0.393,1.274-0.814,1.87-1.27l2.951,2.081c0.475,0.352,1.008,0.483,1.604,0.378c0.604-0.104,1.061-0.409,1.388-0.901 l2.609-3.665c0.324-0.5,0.435-1.036,0.332-1.618c-0.101-0.583-0.387-1.059-0.86-1.41l-2.748-1.899 c0.294-0.688,0.528-1.403,0.722-2.144c0.194-0.738,0.342-1.484,0.452-2.232l3.537-0.616c0.597-0.104,1.063-0.394,1.405-0.883 c0.344-0.488,0.459-1.024,0.355-1.621l-0.775-4.441c-0.099-0.567-0.389-1.025-0.879-1.384c-0.487-0.351-1.027-0.473-1.624-0.369 l-3.239,0.565c-0.299-0.684-0.642-1.358-1.035-2.017c-0.395-0.667-0.816-1.283-1.267-1.85l2.074-2.995 c0.353-0.475,0.484-0.998,0.38-1.59c-0.101-0.583-0.405-1.045-0.904-1.401L111.918,53.649L111.918,53.649z M99.16,64.929 c1.071-0.188,2.118-0.162,3.147,0.075c1.025,0.246,1.953,0.657,2.777,1.231c0.825,0.582,1.523,1.316,2.101,2.198 c0.573,0.889,0.95,1.865,1.139,2.936c0.187,1.072,0.16,2.119-0.076,3.15c-0.246,1.023-0.655,1.949-1.233,2.776 c-0.582,0.823-1.314,1.522-2.196,2.1c-0.889,0.573-1.865,0.951-2.937,1.139c-1.07,0.186-2.117,0.159-3.148-0.077 c-1.025-0.246-1.95-0.655-2.777-1.232c-0.822-0.582-1.522-1.314-2.1-2.196c-0.572-0.889-0.952-1.866-1.138-2.937 c-0.188-1.07-0.162-2.117,0.075-3.148c0.246-1.025,0.657-1.951,1.231-2.778c0.583-0.821,1.316-1.521,2.198-2.099 C97.114,65.494,98.09,65.116,99.16,64.929L99.16,64.929z M40.262,24.224c2.201,0,4.28,0.417,6.252,1.248 c1.961,0.846,3.666,1.986,5.115,3.421c1.435,1.449,2.575,3.156,3.421,5.113c0.833,1.973,1.248,4.054,1.248,6.254 c0,2.201-0.415,4.282-1.248,6.254c-0.846,1.959-1.986,3.666-3.421,5.115c-1.449,1.436-3.154,2.575-5.115,3.421 c-1.972,0.833-4.051,1.248-6.252,1.248s-4.282-0.415-6.255-1.248c-1.958-0.846-3.664-1.985-5.112-3.421 c-1.437-1.449-2.577-3.155-3.423-5.115c-0.831-1.972-1.248-4.053-1.248-6.254c0-2.2,0.417-4.281,1.248-6.254 c0.846-1.958,1.986-3.664,3.423-5.113c1.448-1.435,3.154-2.576,5.112-3.421C35.979,24.641,38.061,24.224,40.262,24.224 L40.262,24.224z' />
    </g>
  </svg>
);

export const pspSvg = (
  <svg
    id='Layer_1'
    data-name='Layer 1'
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 122.88 106.93'
    fillRule='evenodd'
  >
    <path d='M65.5,6.11A42.76,42.76,0,0,0,55.54,9a48,48,0,0,0-7.63,4.13,43.79,43.79,0,0,0-6.54,5.39h0a44.71,44.71,0,0,0-3.55,4H50.73A100,100,0,0,1,65.5,6.11ZM5.13,53.25H71a5.14,5.14,0,0,1,5.13,5.13V101.8A5.16,5.16,0,0,1,71,106.93H5.13A5.14,5.14,0,0,1,0,101.8V58.38a5.16,5.16,0,0,1,5.13-5.13Zm8,42a1.52,1.52,0,1,1,0-3H28.65a1.52,1.52,0,0,1,0,3Zm0-7.2a1.52,1.52,0,0,1,0-3H36.16a1.52,1.52,0,1,1,0,3Zm37.23-4.81a6.88,6.88,0,0,1,5.53,2.78,6.89,6.89,0,1,1,0,8.22,6.89,6.89,0,1,1-5.53-11ZM3.54,63.85h69V58.38a1.59,1.59,0,0,0-.47-1.12A1.61,1.61,0,0,0,71,56.79H5.13a1.57,1.57,0,0,0-1.59,1.59v5.47Zm69,13.61h-69V101.8A1.6,1.6,0,0,0,4,102.93a1.57,1.57,0,0,0,1.12.47H71a1.6,1.6,0,0,0,1.12-.48,1.52,1.52,0,0,0,.48-1.12V77.46ZM111.49,72h.11a49.14,49.14,0,0,0,2.29-4.66l.06-.13A42,42,0,0,0,116.48,59a43.46,43.46,0,0,0,.79-6.19H104.89A44.35,44.35,0,0,1,99.19,72Zm-3.57,5.53H95.75A82.09,82.09,0,0,1,85.6,89.31V81.39q1.75-1.94,3.29-3.88H85.6V72h7.21a40.34,40.34,0,0,0,6.56-19.2H85.6V50A6.74,6.74,0,0,0,85,47.25H99.25q-1-9.47-7.17-19.21H75.63v15.1H70.1V28H53.65a46.92,46.92,0,0,0-6.5,15.1H41.52A49.81,49.81,0,0,1,47.23,28H34.14a47.86,47.86,0,0,0-2.3,4.65l-.06.13a42.27,42.27,0,0,0-2.53,8.24c-.14.68-.26,1.38-.36,2.08H23.3c.15-1.07.32-2.12.53-3.16a48.73,48.73,0,0,1,2.87-9.32l.07-.15A52.16,52.16,0,0,1,31.39,22a48.9,48.9,0,0,1,6.08-7.38,48.34,48.34,0,0,1,7.38-6.07,52.2,52.2,0,0,1,8.52-4.63A49.11,49.11,0,0,1,72.87,0a50.92,50.92,0,0,1,10,1,47.56,47.56,0,0,1,9.32,2.87l.15.06a52.62,52.62,0,0,1,8.52,4.63A49.29,49.29,0,0,1,114.34,22,53,53,0,0,1,119,30.51,47.78,47.78,0,0,1,121.9,40a51.87,51.87,0,0,1,0,20.07A47.26,47.26,0,0,1,119,69.36l-.06.15A53,53,0,0,1,114.34,78a48.34,48.34,0,0,1-6.07,7.38,48.9,48.9,0,0,1-7.38,6.08,52.16,52.16,0,0,1-8.52,4.62,47.88,47.88,0,0,1-6.77,2.32V92.7A44.09,44.09,0,0,0,90.19,91a47.13,47.13,0,0,0,7.63-4.13,42.69,42.69,0,0,0,6.54-5.39h0a43.36,43.36,0,0,0,3.55-4Zm-3.14-30.26h12.49a43.27,43.27,0,0,0-.79-6.19,42.73,42.73,0,0,0-2.58-8.37A50.26,50.26,0,0,0,111.6,28H98.5a47.34,47.34,0,0,1,6.28,19.21ZM57.58,22.51H70.1V9.38A102.12,102.12,0,0,0,57.58,22.51Zm18,0H88.15A102.12,102.12,0,0,0,75.63,9.38V22.51Zm19.37,0h12.92a44.71,44.71,0,0,0-3.55-4h0a43.29,43.29,0,0,0-6.54-5.39A47.09,47.09,0,0,0,90.19,9l-.14-.06A42,42,0,0,0,81.82,6.4c-.52-.11-1-.2-1.59-.29A100,100,0,0,1,95,22.51Z' />
  </svg>
);
export const cmsSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M5 6v8h14v-8h-14zm13 7h-12v-6h12v6zm-8-3c0 .552-.447 1-1 1s-1-.448-1-1 .447-1 1-1 1 .448 1 1zm3 0c0 .552-.447 1-1 1s-1-.448-1-1 .447-1 1-1 1 .448 1 1zm3 0c0 .552-.447 1-1 1s-1-.448-1-1 .447-1 1-1 1 .448 1 1zm-16-10v19h24v-19h-24zm22 17h-20v-15h20v15zm-6.599 4l2.599 3h-12l2.599-3h6.802z' />
  </svg>
);
export const creditCardSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M22 4h-20c-1.104 0-2 .896-2 2v12c0 1.104.896 2 2 2h20c1.104 0 2-.896 2-2v-12c0-1.104-.896-2-2-2zm-19 5.78c0-.431.349-.78.78-.78h.428v1.125h-1.208v-.345zm0 .764h1.208v.968h-1.208v-.968zm0 1.388h1.208v1.068h-.428c-.431 0-.78-.349-.78-.78v-.288zm3 5.068h-3v-1h3v1zm1-4.78c0 .431-.349.78-.78.78h-.429v-1.068h1.209v.288zm0-.708h-1.209v-.968h1.209v.968zm0-1.387h-1.629v2.875h-.743v-4h1.592c.431 0 .78.349.78.78v.345zm4 6.875h-3v-1h3v1zm1-6.5c0-1.381 1.119-2.5 2.5-2.5.484 0 .937.138 1.32.377-.531.552-.857 1.3-.857 2.123 0 .824.327 1.571.857 2.123-.383.239-.836.377-1.32.377-1.381 0-2.5-1.119-2.5-2.5zm4 6.5h-3v-1h3v1zm5 0h-3v-1h3v1zm-2.5-4c-1.38 0-2.5-1.119-2.5-2.5s1.12-2.5 2.5-2.5c1.381 0 2.5 1.119 2.5 2.5s-1.119 2.5-2.5 2.5z' />
  </svg>
);
export const giftCardSVG = (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    fillRule='evenodd'
    clipRule='evenodd'
  >
    <path d='M22 22h-20c-1.104 0-2-.896-2-2v-12c0-1.104.896-2 2-2h1.626l.078.283c.194.631.518 1.221.95 1.717h-2.154c-.276 0-.5.224-.5.5v5.5h20v-5.5c0-.276-.224-.5-.5-.5h-2.154c.497-.569.853-1.264 1.029-2h1.625c1.104 0 2 .896 2 2v12c0 1.104-.896 2-2 2zm-20-5v2.5c0 .276.224.5.5.5h19c.276 0 .5-.224.5-.5v-2.5h-20zm8.911-5h-2.911c.584-1.357 1.295-2.832 2-4-.647-.001-1.572.007-2 0-2.101-.035-2.987-1.806-3-3-.016-1.534 1.205-3.007 3-3 1.499.006 2.814.872 4 2.313 1.186-1.441 2.501-2.307 4-2.313 1.796-.007 3.016 1.466 3 3-.013 1.194-.899 2.965-3 3-.428.007-1.353-.001-2 0 .739 1.198 1.491 2.772 2 4h-2.911c-.241-1.238-.7-2.652-1.089-3.384-.388.732-.902 2.393-1.089 3.384zm-2.553-7.998c-1.131 0-1.507 1.918.12 1.998.237.012 2.235 0 2.235 0-1.037-1.44-1.52-1.998-2.355-1.998zm7.271 0c1.131 0 1.507 1.918-.12 1.998-.237.012-2.222 0-2.222 0 1.037-1.44 1.507-1.998 2.342-1.998z' />
  </svg>
);
export const autofillSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M14.666 8.334v3.666l1.463-2.215-1.463-1.451zm-3.092 4.167c.66-.384 1.242-.864 1.758-1.447v1.369c-.445.393-.926.731-1.449 1.018l-.309-.94zm-3.255 2.041c-.652.083-1.57.125-2.319.125v-.97c.688 0 1.551-.037 2.152-.113l.167.958zm2.789-.725l-.036.015c-.586.246-1.22.437-1.91.573l-.167-.958c.655-.131 1.257-.315 1.809-.556l.304.926zm10.892-13.817l-3 11-4.064-3.62 3.9-4.117-5.229 3.614-3.607-.877 12-6zm-3.015 14.779c0 4.546-5.777 9.221-8.221 9.221h-8.764v-22h11.527l-4 2h-5.527v18h5.938c4.155 0 2.638-6 2.638-6 3.349.921 6.003.403 6.003-3.21.28.65.406 1.318.406 1.989z' />
  </svg>
);
export const menuDotsVerticalSVG = (
  <svg
    clipRule='evenodd'
    fillRule='evenodd'
    strokeLinejoin='round'
    strokeMiterlimit='2'
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='m12 16.495c1.242 0 2.25 1.008 2.25 2.25s-1.008 2.25-2.25 2.25-2.25-1.008-2.25-2.25 1.008-2.25 2.25-2.25zm0-6.75c1.242 0 2.25 1.008 2.25 2.25s-1.008 2.25-2.25 2.25-2.25-1.008-2.25-2.25 1.008-2.25 2.25-2.25zm0-6.75c1.242 0 2.25 1.008 2.25 2.25s-1.008 2.25-2.25 2.25-2.25-1.008-2.25-2.25 1.008-2.25 2.25-2.25z' />
  </svg>
);
export const warningWithCircleSVG = (
  <svg
    clipRule='evenodd'
    fillRule='evenodd'
    strokeLinejoin='round'
    strokeMiterlimit='2'
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='m12.002 21.534c5.518 0 9.998-4.48 9.998-9.998s-4.48-9.997-9.998-9.997c-5.517 0-9.997 4.479-9.997 9.997s4.48 9.998 9.997 9.998zm0-1.5c-4.69 0-8.497-3.808-8.497-8.498s3.807-8.497 8.497-8.497 8.498 3.807 8.498 8.497-3.808 8.498-8.498 8.498zm0-6.5c-.414 0-.75-.336-.75-.75v-5.5c0-.414.336-.75.75-.75s.75.336.75.75v5.5c0 .414-.336.75-.75.75zm-.002 3c.552 0 1-.448 1-1s-.448-1-1-1-1 .448-1 1 .448 1 1 1z'
      fillRule='nonzero'
    />
  </svg>
);
export const warningSVG = (
  <svg
    clipRule='evenodd'
    fillRule='evenodd'
    strokeLinejoin='round'
    strokeMiterlimit='2'
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='m2.095 19.886 9.248-16.5c.133-.237.384-.384.657-.384.272 0 .524.147.656.384l9.248 16.5c.064.115.096.241.096.367 0 .385-.309.749-.752.749h-18.496c-.44 0-.752-.36-.752-.749 0-.126.031-.252.095-.367zm1.935-.384h15.939l-7.97-14.219zm7.972-6.497c-.414 0-.75.336-.75.75v3.5c0 .414.336.75.75.75s.75-.336.75-.75v-3.5c0-.414-.336-.75-.75-.75zm-.002-3c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1z'
      fillRule='nonzero'
    />
  </svg>
);
export const crossSmallSVG = (
  <svg
    clipRule='evenodd'
    fillRule='evenodd'
    strokeLinejoin='round'
    strokeMiterlimit='2'
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='m12 10.93 5.719-5.72c.146-.146.339-.219.531-.219.404 0 .75.324.75.749 0 .193-.073.385-.219.532l-5.72 5.719 5.719 5.719c.147.147.22.339.22.531 0 .427-.349.75-.75.75-.192 0-.385-.073-.531-.219l-5.719-5.719-5.719 5.719c-.146.146-.339.219-.531.219-.401 0-.75-.323-.75-.75 0-.192.073-.384.22-.531l5.719-5.719-5.72-5.719c-.146-.147-.219-.339-.219-.532 0-.425.346-.749.75-.749.192 0 .385.073.531.219z' />
  </svg>
);
export const flaskSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M20.759 20.498l-3.743-7.856c-1.041-2.186-2.016-4.581-2.016-7.007v-2.635h-2c0 3.391-.083 5.188 2.21 10.502l3.743 7.854c.143.302-.068.644-.377.644h-1.246l-4.88-10h-2.984c1.795-4.183 1.528-5.963 1.534-9h-2v2.635c0 2.426-.975 4.82-2.016 7.006l-3.743 7.856c-.165.348-.241.708-.241 1.058 0 1.283 1.023 2.445 2.423 2.445h13.153c1.4 0 2.424-1.162 2.424-2.446 0-.35-.076-.709-.241-1.056zm-13.259 1.502c-.829 0-1.5-.671-1.5-1.5s.671-1.5 1.5-1.5 1.5.671 1.5 1.5-.671 1.5-1.5 1.5zm2.5-4c-.553 0-1-.447-1-1 0-.553.447-1 1-1 .552 0 1 .447 1 1 0 .553-.448 1-1 1zm3 3c-.552 0-1-.448-1-1s.448-1 1-1 1 .448 1 1-.448 1-1 1zm-5-20c0-.552.448-1 1-1h6c.553 0 1 .448 1 1s-.447 1-1 1h-6c-.552 0-1-.448-1-1z' />
  </svg>
);
export const skipArrowSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M6.974 22.957c-10.957-11.421 2.326-20.865 10.384-13.309l-2.464 2.352h9.106v-8.947l-2.232 2.229c-14.794-13.203-31.51 7.051-14.794 17.675z' />
  </svg>
);
export const shipSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M17.133 16.202l1.596.923c-1.508 2.055-3.606 3.548-5.729 3.875v-12.102c0-2.39 2-2.619 2-4.898 0-1.654-1.346-3-3-3s-3 1.346-3 3c0 2.297 2 2.487 2 4.898v12.102c-2.123-.327-4.221-1.799-5.729-3.854l1.596-.944-4.867-2.811v5.621l1.5-.908c2.178 3.077 5.203 4.896 8.5 4.896s6.282-1.798 8.458-4.875l1.542.887v-5.621l-4.867 2.811zm-6.134-12.202c0-.551.449-1 1.001-1s1 .449 1 1-.449 1-1 1-1.001-.449-1.001-1z' />
  </svg>
);
export const discountsSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M12.876 2h-8.876v9.015l10.972 11.124 9.028-9.028-11.124-11.111zm-3.139 5.737c-.684.684-1.791.684-2.475 0s-.684-1.791 0-2.474c.684-.684 1.791-.684 2.475 0 .684.683.684 1.791 0 2.474zm1.866 13.827l-1.369 1.436-10.234-10.257v-7.743h2v6.891l9.603 9.673z' />
  </svg>
);
export const cartSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    fill='none'
  >
    <circle cx='8' cy='21' r='1'></circle>
    <circle cx='19' cy='21' r='1'></circle>
    <path d='M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12'></path>
  </svg>
);
export const importSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M8 9v-4l8 7-8 7v-4h-8v-6h8zm2-7v2h12v16h-12v2h14v-20h-14z' />
  </svg>
);
export const notificationSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M13 16h-2v-6h2v6zm-1-10.25c.69 0 1.25.56 1.25 1.25s-.56 1.25-1.25 1.25-1.25-.56-1.25-1.25.56-1.25 1.25-1.25zm0-2.75c5.514 0 10 3.592 10 8.007 0 4.917-5.145 7.961-9.91 7.961-1.937 0-3.383-.397-4.394-.644-1 .613-1.595 1.037-4.272 1.82.535-1.373.723-2.748.602-4.265-.838-1-2.025-2.4-2.025-4.872-.001-4.415 4.485-8.007 9.999-8.007zm0-2c-6.338 0-12 4.226-12 10.007 0 2.05.738 4.063 2.047 5.625.055 1.83-1.023 4.456-1.993 6.368 2.602-.47 6.301-1.508 7.978-2.536 1.418.345 2.775.503 4.059.503 7.084 0 11.91-4.837 11.91-9.961-.001-5.811-5.702-10.006-12.001-10.006z' />
  </svg>
);
export const securitySVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M12 0c-2.995 2.995-7.486 4-11 4 0 8.582 5.068 16.097 11 20 5.932-3.903 11-11.418 11-20-3.514 0-8.005-1.005-11-4zm-8.912 5.894c2.455-.246 5.912-1.012 8.912-3.25v18.906c-4-3.063-8.254-8.604-8.912-15.656z' />
  </svg>
);
export const syncSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M15.408 21h-9.908c-3.037 0-5.5-2.463-5.5-5.5 0-2.702 1.951-4.945 4.521-5.408.212-3.951 3.473-7.092 7.479-7.092 3.267 0 6.037 2.089 7.063 5.003l-.063-.003c-.681 0-1.336.102-1.958.283-.878-2.025-2.73-3.283-5.042-3.283-3.359 0-5.734 2.562-5.567 6.78-1.954-.113-4.433.923-4.433 3.72 0 1.93 1.57 3.5 3.5 3.5h7.76c.566.81 1.3 1.49 2.148 2zm2.257-8.669c.402-.206.852-.331 1.335-.331 1.455 0 2.67 1.042 2.941 2.418l1.96-.398c-.456-2.291-2.475-4.02-4.901-4.02-.957 0-1.845.278-2.604.745l-1.396-1.745-1 5h5l-1.335-1.669zm5.335 8.669l-1.396-1.745c-.759.467-1.647.745-2.604.745-2.426 0-4.445-1.729-4.901-4.02l1.96-.398c.271 1.376 1.486 2.418 2.941 2.418.483 0 .933-.125 1.335-.331l-1.335-1.669h5l-1 5z' />
  </svg>
);
export const optionsSVG = (
  <svg
    clipRule='evenodd'
    fillRule='evenodd'
    strokeLinejoin='round'
    strokeMiterlimit='2'
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='m10.5 17.25c0-.414.336-.75.75-.75h10c.414 0 .75.336.75.75s-.336.75-.75.75h-10c-.414 0-.75-.336-.75-.75zm-1.5-3.55c0-.53-.47-1-1-1h-5c-.53 0-1 .47-1 1v4.3c0 .53.47 1 1 1h5c.53 0 1-.47 1-1zm1.5-1.7c0-.414.336-.75.75-.75h10c.414 0 .75.336.75.75s-.336.75-.75.75h-10c-.414 0-.75-.336-.75-.75zm-1.5-6c0-.53-.47-1-1-1h-5c-.53 0-1 .47-1 1v4.3c0 .53.47 1 1 1h5c.53 0 1-.47 1-1zm1.5.75c0-.414.336-.75.75-.75h10c.414 0 .75.336.75.75s-.336.75-.75.75h-10c-.414 0-.75-.336-.75-.75z'
      fillRule='nonzero'
    />
  </svg>
);
export const designSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M20 19h-4v-4h4v4zm-6-10h-4v4h4v-4zm6 0h-4v4h4v-4zm-12 6h-4v4h4v-4zm16-14v22h-24v-22h24zm-2 6h-20v14h20v-14zm-8 8h-4v4h4v-4zm-6-6h-4v4h4v-4z' />
  </svg>
);
export const uploadSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M12 5c3.453 0 5.891 2.797 5.567 6.78 1.745-.046 4.433.751 4.433 3.72 0 1.93-1.57 3.5-3.5 3.5h-13c-1.93 0-3.5-1.57-3.5-3.5 0-2.797 2.479-3.833 4.433-3.72-.167-4.218 2.208-6.78 5.567-6.78zm0-2c-4.006 0-7.267 3.141-7.479 7.092-2.57.463-4.521 2.706-4.521 5.408 0 3.037 2.463 5.5 5.5 5.5h13c3.037 0 5.5-2.463 5.5-5.5 0-2.702-1.951-4.945-4.521-5.408-.212-3.951-3.473-7.092-7.479-7.092zm4 10h-3v4h-2v-4h-3l4-4 4 4z' />
  </svg>
);
export const downloadSVG = (
  <svg
    clipRule='evenodd'
    fillRule='evenodd'
    width='24'
    height='24'
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M23 24v-20h-8v2h6v16h-18v-16h6v-2h-8v20h22zm-12-13h-4l5 6 5-6h-4v-11h-2v11z' />
  </svg>
);
export const userManualSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M5.495 2h16.505v-2h-17c-1.656 0-3 1.343-3 3v18c0 1.657 1.344 3 3 3h17v-20h-16.505c-1.376 0-1.376-2 0-2zm.505 4h14v16h-14v-16zm5.211 11.365c.464-1.469 1.342-3.229 1.496-3.675.225-.646-.174-.934-1.429.171l-.278-.525c1.432-1.559 4.381-1.91 3.378.504-.627 1.508-1.075 2.525-1.331 3.31-.374 1.144.569.68 1.493-.173.127.206.167.271.294.508-2.054 1.953-4.331 2.125-3.623-.12zm3.895-6.71c-.437.372-1.084.364-1.446-.018-.361-.382-.302-.992.135-1.364.438-.372 1.084-.363 1.446.018.362.382.302.993-.135 1.364z' />
  </svg>
);
export const fastcheckoutSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M15.91 13.34l2.636-4.026-.454-.406-3.673 3.099c-.675-.138-1.402.068-1.894.618-.736.823-.665 2.088.159 2.824.824.736 2.088.665 2.824-.159.492-.55.615-1.295.402-1.95zm-3.91-10.646v-2.694h4v2.694c-1.439-.243-2.592-.238-4 0zm8.851 2.064l1.407-1.407 1.414 1.414-1.321 1.321c-.462-.484-.964-.927-1.5-1.328zm-18.851 4.242h8v2h-8v-2zm-2 4h8v2h-8v-2zm3 4h7v2h-7v-2zm21-3c0 5.523-4.477 10-10 10-2.79 0-5.3-1.155-7.111-3h3.28c1.138.631 2.439 1 3.831 1 4.411 0 8-3.589 8-8s-3.589-8-8-8c-1.392 0-2.693.369-3.831 1h-3.28c1.811-1.845 4.321-3 7.111-3 5.523 0 10 4.477 10 10z' />
  </svg>
);
export const socialCommerceSVG = (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    fillRule='evenodd'
    clipRule='evenodd'
  >
    <path d='M14.889 23.652c-.923.227-1.888.348-2.881.348-6.627 0-12.008-5.377-12.008-12s5.381-12 12.008-12c6.628 0 12.009 5.377 12.009 12 0 1.027-.13 2.023-.373 2.975l-.965-.34c.21-.847.321-1.732.321-2.643 0-6.066-4.929-10.992-11-10.992s-11 4.926-11 10.992c0 6.067 4.929 10.993 11 10.993.887 0 1.751-.106 2.577-.304l.312.971zm-2.889-13.652c-1.104 0-2 .896-2 2s.896 2 2 2c.28 0 .546-.057.788-.162l3.06 9.525 2.174-3.622 4.116 4.259 1.879-1.828-4.087-4.216 3.671-1.926-9.694-3.426c.06-.19.093-.393.093-.604 0-1.104-.896-2-2-2zm1.768 3.615l7.333 2.597-2.823 1.481 4.324 4.461-.445.431-4.324-4.473-1.716 2.86-2.349-7.357zm.049 6.692c-.583.126-1.188.193-1.809.193-4.691 0-8.5-3.809-8.5-8.5s3.809-8.5 8.5-8.5c4.692 0 8.5 3.809 8.5 8.5 0 .619-.066 1.222-.192 1.803l-.959-.337c.094-.474.143-.964.143-1.466 0-4.139-3.361-7.5-7.5-7.5-4.139 0-7.5 3.361-7.5 7.5 0 4.139 3.361 7.5 7.5 7.5.517 0 1.022-.052 1.51-.152l.307.959zm-1.076-3.36c-.239.035-.484.053-.733.053-2.759 0-5-2.24-5-5s2.241-5 5-5c2.76 0 5 2.24 5 5 0 .212-.013.421-.039.626l-.979-.345.01-.281c0-2.208-1.792-4-4-4s-4 1.792-4 4 1.792 4 4 4l.43-.023.311.97zm-.741-5.947c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1z' />
  </svg>
);
export const stripeSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='12'
    height='12'
    viewBox='0 0 24 24'
  >
    <path d='M21.5 6c.276 0 .5.224.5.5v11c0 .276-.224.5-.5.5h-19c-.276 0-.5-.224-.5-.5v-11c0-.276.224-.5.5-.5h19zm2.5 0c0-1.104-.896-2-2-2h-20c-1.105 0-2 .896-2 2v12c0 1.104.895 2 2 2h20c1.104 0 2-.896 2-2v-12zm-4 6.509c0-1.137-.55-2.034-1.605-2.034-1.056 0-1.698.898-1.698 2.028 0 1.338.758 2.015 1.838 2.015.53 0 .929-.121 1.23-.288v-.894c-.303.153-.65.246-1.09.246-.433 0-.814-.153-.863-.673h2.173l.015-.4zm-2.197-.419c0-.5.308-.71.586-.71.273 0 .561.21.561.71h-1.147zm-2.822-1.615c-.435 0-.716.205-.869.348l-.058-.274h-.977v5.181l1.11-.236.002-1.256c.159.117.397.281.785.281.794 0 1.52-.639 1.52-2.049.001-1.293-.733-1.995-1.513-1.995zm-.265 3.063c-.26 0-.416-.094-.523-.211l-.007-1.649c.116-.127.275-.22.53-.22.406 0 .686.455.686 1.036 0 .597-.276 1.044-.686 1.044zm-3.169-3.327l1.114-.237v-.904l-1.114.237v.904zm0 4.228h1.114v-3.89h-1.114v3.89zm-1.194-3.562l-.07-.328h-.96v3.89h1.109v-2.637c.262-.344.705-.278.846-.232v-1.02c-.146-.054-.665-.15-.925.327zm-2.226-1.292l-1.084.23-.005 3.561c0 .657.494 1.142 1.153 1.142.363 0 .631-.066.779-.147v-.903c-.142.057-.843.261-.843-.394v-1.579h.843v-.946h-.842l-.001-.964zm-3.004 2.093c0-.173.144-.241.377-.241.338 0 .766.103 1.104.286v-1.045c-.368-.147-.735-.203-1.103-.203-.9 0-1.5.47-1.5 1.256 0 1.229 1.687 1.029 1.687 1.559 0 .205-.178.271-.426.271-.368 0-.842-.152-1.215-.354v1.06c.413.178.831.252 1.214.252.923 0 1.559-.456 1.559-1.255-.001-1.323-1.697-1.086-1.697-1.586z' />
  </svg>
);
export const euro14SVG = (
  <svg style={{ width: 100, height: 50 }}>
    <text x='0' y='40' fontSize={50} fontFamily='italic'>
      €14
    </text>
  </svg>
);
export const euro49SVG = (
  <svg style={{ width: 100, height: 50 }}>
    <text x='0' y='40' fontSize={50} fontFamily='italic'>
      €49
    </text>
  </svg>
);
export const subscribeSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M5.48 10.089l1.583-1.464c1.854.896 3.028 1.578 5.11 3.063 3.916-4.442 6.503-6.696 11.311-9.688l.516 1.186c-3.965 3.46-6.87 7.314-11.051 14.814-2.579-3.038-4.301-4.974-7.469-7.911zm14.407.557c.067.443.113.893.113 1.354 0 4.962-4.038 9-9 9s-9-4.038-9-9 4.038-9 9-9c1.971 0 3.79.644 5.274 1.723.521-.446 1.052-.881 1.6-1.303-1.884-1.511-4.271-2.42-6.874-2.42-6.075 0-11 4.925-11 11s4.925 11 11 11 11-4.925 11-11c0-1.179-.19-2.313-.534-3.378-.528.633-1.052 1.305-1.579 2.024z' />
  </svg>
);
export const shareSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M5 7c2.761 0 5 2.239 5 5s-2.239 5-5 5-5-2.239-5-5 2.239-5 5-5zm11.122 12.065c-.073.301-.122.611-.122.935 0 2.209 1.791 4 4 4s4-1.791 4-4-1.791-4-4-4c-1.165 0-2.204.506-2.935 1.301l-5.488-2.927c-.23.636-.549 1.229-.943 1.764l5.488 2.927zm7.878-15.065c0-2.209-1.791-4-4-4s-4 1.791-4 4c0 .324.049.634.122.935l-5.488 2.927c.395.535.713 1.127.943 1.764l5.488-2.927c.731.795 1.77 1.301 2.935 1.301 2.209 0 4-1.791 4-4z' />
  </svg>
);
export const successSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-1.25 16.518l-4.5-4.319 1.396-1.435 3.078 2.937 6.105-6.218 1.421 1.409-7.5 7.626z' />
  </svg>
);
export const errorSVG = (
  <svg
    clipRule='evenodd'
    fillRule='evenodd'
    strokeLinejoin='round'
    strokeMiterlimit='2'
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='m12.002 21.534c5.518 0 9.998-4.48 9.998-9.998s-4.48-9.997-9.998-9.997c-5.517 0-9.997 4.479-9.997 9.997s4.48 9.998 9.997 9.998zm0-8c-.414 0-.75-.336-.75-.75v-5.5c0-.414.336-.75.75-.75s.75.336.75.75v5.5c0 .414-.336.75-.75.75zm-.002 3c-.552 0-1-.448-1-1s.448-1 1-1 1 .448 1 1-.448 1-1 1z'
      fillRule='nonzero'
    />
  </svg>
);
export const download2SVG = (
  <svg
    clipRule='evenodd'
    fillRule='evenodd'
    strokeLinejoin='round'
    strokeMiterlimit='2'
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='m6.864 3.424c.502-.301 1.136.063 1.136.642 0 .264-.138.509-.365.644-2.476 1.486-4.135 4.197-4.135 7.292 0 4.691 3.808 8.498 8.498 8.498s8.497-3.807 8.497-8.498c0-3.093-1.656-5.803-4.131-7.289-.225-.136-.364-.38-.364-.644 0-.582.635-.943 1.137-.642 2.91 1.748 4.858 4.936 4.858 8.575 0 5.519-4.479 9.998-9.997 9.998s-9.998-4.479-9.998-9.998c0-3.641 1.951-6.83 4.864-8.578zm.831 8.582s2.025 2.021 3.779 3.774c.147.147.339.22.53.22.192 0 .384-.073.531-.22 1.753-1.752 3.779-3.775 3.779-3.775.145-.145.217-.336.217-.526 0-.192-.074-.384-.221-.531-.292-.293-.766-.294-1.056-.004l-2.5 2.499v-10.693c0-.414-.336-.75-.75-.75s-.75.336-.75.75v10.693l-2.498-2.498c-.289-.289-.762-.286-1.054.006-.147.147-.221.339-.222.531 0 .19.071.38.215.524z'
      fillRule='nonzero'
    />
  </svg>
);
export const webhookSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    version='1.1'
    id='mdiWebhook'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M10.46,19C9,21.07 6.15,21.59 4.09,20.15C2.04,18.71 1.56,15.84 3,13.75C3.87,12.5 5.21,11.83 6.58,11.77L6.63,13.2C5.72,13.27 4.84,13.74 4.27,14.56C3.27,16 3.58,17.94 4.95,18.91C6.33,19.87 8.26,19.5 9.26,18.07C9.57,17.62 9.75,17.13 9.82,16.63V15.62L15.4,15.58L15.47,15.47C16,14.55 17.15,14.23 18.05,14.75C18.95,15.27 19.26,16.43 18.73,17.35C18.2,18.26 17.04,18.58 16.14,18.06C15.73,17.83 15.44,17.46 15.31,17.04L11.24,17.06C11.13,17.73 10.87,18.38 10.46,19M17.74,11.86C20.27,12.17 22.07,14.44 21.76,16.93C21.45,19.43 19.15,21.2 16.62,20.89C15.13,20.71 13.9,19.86 13.19,18.68L14.43,17.96C14.92,18.73 15.75,19.28 16.75,19.41C18.5,19.62 20.05,18.43 20.26,16.76C20.47,15.09 19.23,13.56 17.5,13.35C16.96,13.29 16.44,13.36 15.97,13.53L15.12,13.97L12.54,9.2H12.32C11.26,9.16 10.44,8.29 10.47,7.25C10.5,6.21 11.4,5.4 12.45,5.44C13.5,5.5 14.33,6.35 14.3,7.39C14.28,7.83 14.11,8.23 13.84,8.54L15.74,12.05C16.36,11.85 17.04,11.78 17.74,11.86M8.25,9.14C7.25,6.79 8.31,4.1 10.62,3.12C12.94,2.14 15.62,3.25 16.62,5.6C17.21,6.97 17.09,8.47 16.42,9.67L15.18,8.95C15.6,8.14 15.67,7.15 15.27,6.22C14.59,4.62 12.78,3.85 11.23,4.5C9.67,5.16 8.97,7 9.65,8.6C9.93,9.26 10.4,9.77 10.97,10.11L11.36,10.32L8.29,15.31C8.32,15.36 8.36,15.42 8.39,15.5C8.88,16.41 8.54,17.56 7.62,18.05C6.71,18.54 5.56,18.18 5.06,17.24C4.57,16.31 4.91,15.16 5.83,14.67C6.22,14.46 6.65,14.41 7.06,14.5L9.37,10.73C8.9,10.3 8.5,9.76 8.25,9.14Z' />
  </svg>
);
export const marketingSVG = (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    fillRule='evenodd'
    clipRule='evenodd'
  >
    <path d='M18 24.083h-12c-1.104 0-2-.896-2-2v-20c0-1.104.896-2 2-2h12c1.104 0 2 .896 2 2v20c0 1.104-.896 2-2 2zm1-5.083h-14v3.083c0 .552.449 1 1 1h12c.552 0 1-.448 1-1v-3.083zm-7 3c-.553 0-1-.448-1-1s.447-1 1-1c.552 0 .999.448.999 1s-.447 1-.999 1zm7-17h-14v13h14v-13zm-6.511 3.538c-.251-.765-1.577-.659-1.53.29-.143.313-.78 1.434-2.894 2.471-.667.326-1.065.927-1.065 1.606 0 1.111 1.023 1.805 2.085 1.644l1.043 1.153c.063.069.411.423.94.252l.608-.203c.506-.169.605-.749.377-1.085l-.538-.836c.566-.089 1.191-.018 1.454.04.199.236.552.34.846.237.41-.135.633-.58.49-1.019l-1.816-4.55zm-2.456 4.74l1.067 1.663-.292.097-1.411-1.558-.29.093c-.385.119-.919.067-1.103-.389-.147-.368 0-.797.478-1.032 2.193-1.077 3.017-2.284 3.297-2.834l1.45 3.64c-1.61-.393-2.974.241-3.196.32zm6.967-2.122c0 .155-.012.984-.36 1.68l-.868-.375c.372-.882.358-1.727.046-2.5-.32-.788-.909-1.4-1.771-1.759l.371-.87c.49.163 2.582 1.254 2.582 3.824zm-1.597-1.025c.299.736.248 1.545-.044 2.149l-.852-.356c.181-.465.252-.909.035-1.443-.202-.5-.553-.807-1.031-1.009l.362-.858c.764.319 1.261.854 1.53 1.517zm2.597-9.048h-12c-.551 0-1 .449-1 1v1.917h14v-1.917c0-.551-.448-1-1-1zm-4.5 1.917h-3c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h3c.276 0 .5.224.5.5s-.224.5-.5.5z' />
  </svg>
);
export const supportSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M12 1c-6.338 0-12 4.226-12 10.007 0 2.05.738 4.063 2.047 5.625.055 1.83-1.023 4.456-1.993 6.368 2.602-.47 6.301-1.508 7.978-2.536 9.236 2.247 15.968-3.405 15.968-9.457 0-5.812-5.701-10.007-12-10.007zm0 15c-.565 0-1.024-.459-1.024-1.025 0-.565.459-1.024 1.024-1.024.566 0 1.024.459 1.024 1.024 0 .566-.458 1.025-1.024 1.025zm1.606-4.858c-.74.799-.775 1.241-.766 1.785h-1.643c-.006-1.208.016-1.742 1.173-2.842.469-.446.84-.799.788-1.493-.047-.66-.599-1.004-1.117-1.004-.581 0-1.261.432-1.261 1.649h-1.646c0-1.966 1.155-3.237 2.941-3.237.849 0 1.592.278 2.09.783.468.473.709 1.125.7 1.883-.013 1.134-.704 1.878-1.259 2.476z' />
  </svg>
);
export const homeSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M12 9.185l7 6.514v6.301h-3v-5h-8v5h-3v-6.301l7-6.514zm0-2.732l-9 8.375v9.172h7v-5h4v5h7v-9.172l-9-8.375zm12 5.695l-12-11.148-12 11.133 1.361 1.465 10.639-9.868 10.639 9.883 1.361-1.465z' />
  </svg>
);
export const halfStarSVG = (
  <svg
    clipRule='evenodd'
    fillRule='evenodd'
    strokeLinejoin='round'
    strokeMiterlimit='2'
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='m11.322 2.923c.126-.259.39-.423.678-.423.289 0 .552.164.678.423.974 1.998 2.65 5.44 2.65 5.44s3.811.524 6.022.829c.403.055.65.396.65.747 0 .19-.072.383-.231.536-1.61 1.538-4.382 4.191-4.382 4.191s.677 3.767 1.069 5.952c.083.462-.275.882-.742.882-.122 0-.244-.029-.355-.089-1.968-1.048-5.359-2.851-5.359-2.851s-3.391 1.803-5.359 2.851c-.111.06-.234.089-.356.089-.465 0-.825-.421-.741-.882.393-2.185 1.07-5.952 1.07-5.952s-2.773-2.653-4.382-4.191c-.16-.153-.232-.346-.232-.535 0-.352.249-.694.651-.748 2.211-.305 6.021-.829 6.021-.829s1.677-3.442 2.65-5.44zm.678 2.033v11.904l4.707 2.505-.951-5.236 3.851-3.662-5.314-.756z'
      fillRule='nonzero'
    />
  </svg>
);
export const writeSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M15.812 4.819c-.33-.341-.312-.877.028-1.207l3.469-3.365c.17-.164.387-.247.603-.247.219 0 .438.085.604.257l-4.704 4.562zm-5.705 8.572c-.07.069-.107.162-.107.255 0 .194.158.354.354.354.089 0 .178-.033.247-.1l.583-.567-.493-.509-.584.567zm4.924-6.552l-1.994 1.933c-1.072 1.039-1.619 2.046-2.124 3.451l.881.909c1.419-.461 2.442-.976 3.514-2.016l1.994-1.934-2.271-2.343zm5.816-5.958l-5.137 4.982 2.586 2.671 5.138-4.98c.377-.366.566-.851.566-1.337 0-1.624-1.968-2.486-3.153-1.336zm-11.847 12.119h-4v1h4v-1zm9-1.35v1.893c0 4.107-6 2.457-6 2.457s1.518 6-2.638 6h-7.362v-20h12.629l2.062-2h-16.691v24h10.189c3.163 0 9.811-7.223 9.811-9.614v-4.687l-2 1.951z' />
  </svg>
);
export const filterSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M6 18h-2v5h-2v-5h-2v-3h6v3zm-2-17h-2v12h2v-12zm11 7h-6v3h2v12h2v-12h2v-3zm-2-7h-2v5h2v-5zm11 14h-6v3h2v5h2v-5h2v-3zm-2-14h-2v12h2v-12z' />
  </svg>
);

export const linkSVG = (
  <svg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg' fill='none'>
    <g>
      <path d='M9 .75A.75.75 0 019.75 0h4.5c.206 0 .393.083.529.218l.001.002.002.001A.748.748 0 0115 .75v4.5a.75.75 0 01-1.5 0V2.56L7.28 8.78a.75.75 0 01-1.06-1.06l6.22-6.22H9.75A.75.75 0 019 .75z' />

      <path d='M3.25 3.5a.75.75 0 00-.75.75v7.5c0 .414.336.75.75.75h7.5a.75.75 0 00.75-.75v-4a.75.75 0 011.5 0v4A2.25 2.25 0 0110.75 14h-7.5A2.25 2.25 0 011 11.75v-7.5A2.25 2.25 0 013.25 2h4a.75.75 0 010 1.5h-4z' />
    </g>
  </svg>
);
export const cubeSVG = (
  <svg
    clipRule='evenodd'
    fillRule='evenodd'
    strokeLinejoin='round'
    strokeMiterlimit='2'
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='m3.514 6.61c-.317.179-.514.519-.514.887v8.95c0 .37.197.708.514.887 1.597.901 6.456 3.639 8.005 4.512.152.085.319.128.487.128.164 0 .328-.041.477-.123 1.549-.855 6.39-3.523 7.994-4.408.323-.177.523-.519.523-.891v-9.055c0-.368-.197-.708-.515-.887-1.595-.899-6.444-3.632-7.999-4.508-.151-.085-.319-.128-.486-.128-.168 0-.335.043-.486.128-1.555.876-6.405 3.609-8 4.508m15.986 2.115v7.525l-6.75 3.722v-7.578zm-15 7.425v-7.458l6.75 3.75v7.511zm.736-8.769 6.764-3.813 6.801 3.834-6.801 3.716z'
      fillRule='nonzero'
    />
  </svg>
);
export const shoppingBagSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M20 7h-4v-3c0-2.209-1.791-4-4-4s-4 1.791-4 4v3h-4l-2 17h20l-2-17zm-11-3c0-1.654 1.346-3 3-3s3 1.346 3 3v3h-6v-3zm-4.751 18l1.529-13h2.222v1.5c0 .276.224.5.5.5s.5-.224.5-.5v-1.5h6v1.5c0 .276.224.5.5.5s.5-.224.5-.5v-1.5h2.222l1.529 13h-15.502z' />
  </svg>
);
export const twoUsersSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M10.118 16.064c2.293-.529 4.428-.993 3.394-2.945-3.146-5.942-.834-9.119 2.488-9.119 3.388 0 5.644 3.299 2.488 9.119-1.065 1.964 1.149 2.427 3.394 2.945 1.986.459 2.118 1.43 2.118 3.111l-.003.825h-15.994c0-2.196-.176-3.407 2.115-3.936zm-10.116 3.936h6.001c-.028-6.542 2.995-3.697 2.995-8.901 0-2.009-1.311-3.099-2.998-3.099-2.492 0-4.226 2.383-1.866 6.839.775 1.464-.825 1.812-2.545 2.209-1.49.344-1.589 1.072-1.589 2.333l.002.619z' />
  </svg>
);
export const trackingSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M11.5 12.5l1.13 4.5 3.37-9-9 3.375 4.5 1.125zm.5-12.5c-6.627 0-12 5.373-12 12 0 6.616 5.408 12 12 12 6.627 0 12-5.373 12-12s-5.373-12-12-12zm-11 12c0-6.065 4.935-11 11-11v2c-4.963 0-9 4.038-9 9 0 2.547 1.074 4.838 2.781 6.477l-1.47 1.36c-2.036-1.997-3.311-4.766-3.311-7.837zm11 8c-4.336 0-8-3.562-8-8 0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z' />
  </svg>
);
export const classesSVG = (
  <svg
    clipRule='evenodd'
    fillRule='evenodd'
    strokeLinejoin='round'
    strokeMiterlimit='2'
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='m3.3 15.4c.717 0 1.3.583 1.3 1.3s-.583 1.3-1.3 1.3-1.3-.583-1.3-1.3.583-1.3 1.3-1.3zm2.7 1.85c0-.414.336-.75.75-.75h14.5c.414 0 .75.336.75.75s-.336.75-.75.75h-14.5c-.414 0-.75-.336-.75-.75zm-2.7-6.55c.717 0 1.3.583 1.3 1.3s-.583 1.3-1.3 1.3-1.3-.583-1.3-1.3.583-1.3 1.3-1.3zm2.7 1.3c0-.414.336-.75.75-.75h14.5c.414 0 .75.336.75.75s-.336.75-.75.75h-14.5c-.414 0-.75-.336-.75-.75zm-2.7-6c.717 0 1.3.583 1.3 1.3s-.583 1.3-1.3 1.3-1.3-.583-1.3-1.3.583-1.3 1.3-1.3zm2.7.75c0-.414.336-.75.75-.75h14.5c.414 0 .75.336.75.75s-.336.75-.75.75h-14.5c-.414 0-.75-.336-.75-.75z'
      fillRule='nonzero'
    />
  </svg>
);
export const hourGlassSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M18.513 7.119c.958-1.143 1.487-2.577 1.487-4.036v-3.083h-16v3.083c0 1.459.528 2.892 1.487 4.035l3.087 3.68c.566.677.57 1.625.009 2.306l-3.13 3.794c-.937 1.136-1.453 2.555-1.453 3.995v3.107h16v-3.107c0-1.44-.517-2.858-1.453-3.994l-3.13-3.794c-.562-.681-.558-1.629.009-2.306l3.087-3.68zm-.513-4.12c0 1.101-.363 2.05-1.02 2.834l-.978 1.167h-8.004l-.978-1.167c-.66-.785-1.02-1.736-1.02-2.834h12zm-.996 15.172c.652.791.996 1.725.996 2.829h-1.061c-1.939-2-4.939-2-4.939-2s-3 0-4.939 2h-1.061c0-1.104.344-2.039.996-2.829l3.129-3.793c.342-.415.571-.886.711-1.377h.164v1h2v-1h.163c.141.491.369.962.711 1.376l3.13 3.794zm-6.004-1.171h2v1h-2v-1zm0-2h2v1h-2v-1z' />
  </svg>
);
export const rocketSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M23.948.042c-.413-.028-.817-.042-1.214-.042-8.6 0-13.497 6.557-15.278 11.833l4.727 4.727c5.428-1.944 11.817-6.66 11.817-15.168 0-.44-.017-.89-.052-1.35zm-11.277 14.178l-2.883-2.883c1.221-2.859 4.691-8.945 12.199-9.32-.251 5.775-4.041 9.932-9.316 12.203zm5.471 1.538c-.547.373-1.09.71-1.628 1.011-.187.891-.662 1.842-1.351 2.652-.002-.576-.162-1.156-.443-1.738-.495.225-.966.418-1.414.588.66 1.709-.012 2.971-.915 4.154 1.296-.098 2.656-.732 3.728-1.805 1.155-1.155 1.967-2.823 2.023-4.862zm-11.82-6.469c-.579-.28-1.158-.438-1.732-.441.803-.681 1.744-1.153 2.626-1.345.314-.552.667-1.097 1.039-1.633-2.039.055-3.708.867-4.864 2.023-1.071 1.071-1.706 2.433-1.804 3.728 1.184-.904 2.446-1.576 4.155-.914.173-.471.366-.944.58-1.418zm7.738.663c-.391-.391-.391-1.023 0-1.414s1.023-.391 1.414 0c.391.392.391 1.024 0 1.415s-1.024.39-1.414-.001zm4.949-4.951c-.78-.78-2.047-.78-2.828 0-.781.781-.781 2.049 0 2.829.781.781 2.048.781 2.829 0 .78-.78.78-2.047-.001-2.829zm-1.908 1.911c-.273-.273-.273-.718 0-.99.271-.273.717-.273.99 0 .272.272.271.717 0 .99-.274.272-.718.272-.99 0zm-6.747 10.65c-1.492 3.81-5.803 6.208-10.354 6.438.219-4.289 2.657-8.676 6.64-10.153l.805.806c-4.331 2.755-4.653 5.346-4.665 6.575 1.268-.015 4.054-.344 6.778-4.464l.796.798z' />
  </svg>
);
export const questionSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm1.25 17c0 .69-.559 1.25-1.25 1.25-.689 0-1.25-.56-1.25-1.25s.561-1.25 1.25-1.25c.691 0 1.25.56 1.25 1.25zm1.393-9.998c-.608-.616-1.515-.955-2.551-.955-2.18 0-3.59 1.55-3.59 3.95h2.011c0-1.486.829-2.013 1.538-2.013.634 0 1.307.421 1.364 1.226.062.847-.39 1.277-.962 1.821-1.412 1.343-1.438 1.993-1.432 3.468h2.005c-.013-.664.03-1.203.935-2.178.677-.73 1.519-1.638 1.536-3.022.011-.924-.284-1.719-.854-2.297z' />
  </svg>
);
export const codeSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M24 10.935v2.131l-10 4.934v-2.23l7.64-3.77-7.64-3.779v-2.221l10 4.935zm-24 0v2.131l10 4.934v-2.23l-7.64-3.77 7.64-3.779v-2.221l-10 4.935z' />
  </svg>
);
export const playSVG = (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M18.54,9,8.88,3.46a3.42,3.42,0,0,0-5.13,3V17.58A3.42,3.42,0,0,0,7.17,21a3.43,3.43,0,0,0,1.71-.46L18.54,15a3.42,3.42,0,0,0,0-5.92Zm-1,4.19L7.88,18.81a1.44,1.44,0,0,1-1.42,0,1.42,1.42,0,0,1-.71-1.23V6.42a1.42,1.42,0,0,1,.71-1.23A1.51,1.51,0,0,1,7.17,5a1.54,1.54,0,0,1,.71.19l9.66,5.58a1.42,1.42,0,0,1,0,2.46Z' />
  </svg>
);
export const pulseSVG = (
  <svg
    width='24'
    height='24'
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M11.8 9L10 3H9L7.158 9.64 5.99 4.69h-.97L3.85 9H1v.99h3.23l.49-.37.74-2.7L6.59 12h1.03l1.87-7.04 1.46 4.68.48.36H15V9h-3.2z' />
  </svg>
);
export const slackSVG = (
  <svg viewBox='0 0 24 24'>
    <path d='M5.042 15.165a2.528 2.528 0 0 1-2.52 2.523A2.528 2.528 0 0 1 0 15.165a2.527 2.527 0 0 1 2.522-2.52h2.52v2.52zM6.313 15.165a2.527 2.527 0 0 1 2.521-2.52 2.527 2.527 0 0 1 2.521 2.52v6.313A2.528 2.528 0 0 1 8.834 24a2.528 2.528 0 0 1-2.521-2.522v-6.313zM8.834 5.042a2.528 2.528 0 0 1-2.521-2.52A2.528 2.528 0 0 1 8.834 0a2.528 2.528 0 0 1 2.521 2.522v2.52H8.834zM8.834 6.313a2.528 2.528 0 0 1 2.521 2.521 2.528 2.528 0 0 1-2.521 2.521H2.522A2.528 2.528 0 0 1 0 8.834a2.528 2.528 0 0 1 2.522-2.521h6.312zM18.956 8.834a2.528 2.528 0 0 1 2.522-2.521A2.528 2.528 0 0 1 24 8.834a2.528 2.528 0 0 1-2.522 2.521h-2.522V8.834zM17.688 8.834a2.528 2.528 0 0 1-2.523 2.521 2.527 2.527 0 0 1-2.52-2.521V2.522A2.527 2.527 0 0 1 15.165 0a2.528 2.528 0 0 1 2.523 2.522v6.312zM15.165 18.956a2.528 2.528 0 0 1 2.523 2.522A2.528 2.528 0 0 1 15.165 24a2.527 2.527 0 0 1-2.52-2.522v-2.522h2.52zM15.165 17.688a2.527 2.527 0 0 1-2.52-2.523 2.526 2.526 0 0 1 2.52-2.52h6.313A2.527 2.527 0 0 1 24 15.165a2.528 2.528 0 0 1-2.522 2.523h-6.313z'></path>
  </svg>
);
export const whatsappSVG = (
  <svg viewBox='0 0 24 24'>
    <path d='M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488'></path>
  </svg>
);
export const slackOriginalSVG = (
  <svg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M26.5002 14.9996C27.8808 14.9996 29 13.8804 29 12.4998C29 11.1192 27.8807 10 26.5001 10C25.1194 10 24 11.1193 24 12.5V14.9996H26.5002ZM19.5 14.9996C20.8807 14.9996 22 13.8803 22 12.4996V5.5C22 4.11929 20.8807 3 19.5 3C18.1193 3 17 4.11929 17 5.5V12.4996C17 13.8803 18.1193 14.9996 19.5 14.9996Z'
      fill='#2EB67D'
    />
    <path
      d='M5.49979 17.0004C4.11919 17.0004 3 18.1196 3 19.5002C3 20.8808 4.1193 22 5.49989 22C6.8806 22 8 20.8807 8 19.5V17.0004H5.49979ZM12.5 17.0004C11.1193 17.0004 10 18.1197 10 19.5004V26.5C10 27.8807 11.1193 29 12.5 29C13.8807 29 15 27.8807 15 26.5V19.5004C15 18.1197 13.8807 17.0004 12.5 17.0004Z'
      fill='#E01E5A'
    />
    <path
      d='M17.0004 26.5002C17.0004 27.8808 18.1196 29 19.5002 29C20.8808 29 22 27.8807 22 26.5001C22 25.1194 20.8807 24 19.5 24L17.0004 24L17.0004 26.5002ZM17.0004 19.5C17.0004 20.8807 18.1197 22 19.5004 22L26.5 22C27.8807 22 29 20.8807 29 19.5C29 18.1193 27.8807 17 26.5 17L19.5004 17C18.1197 17 17.0004 18.1193 17.0004 19.5Z'
      fill='#ECB22E'
    />
    <path
      d='M14.9996 5.49979C14.9996 4.11919 13.8804 3 12.4998 3C11.1192 3 10 4.1193 10 5.49989C10 6.88061 11.1193 8 12.5 8L14.9996 8L14.9996 5.49979ZM14.9996 12.5C14.9996 11.1193 13.8803 10 12.4996 10L5.5 10C4.11929 10 3 11.1193 3 12.5C3 13.8807 4.11929 15 5.5 15L12.4996 15C13.8803 15 14.9996 13.8807 14.9996 12.5Z'
      fill='#36C5F0'
    />
  </svg>
);
export const ToggleSideBarSVG = (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M20 6H13'
      stroke='#8B909A'
      strokeWidth='1.75'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M20 12H11'
      stroke='#8B909A'
      strokeWidth='1.75'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M20 18H13'
      stroke='#8B909A'
      strokeWidth='1.75'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M8 8L4 12L8 16'
      stroke='#8B909A'
      strokeWidth='1.75'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const fingerPrintSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    stroke='var(--main-text-color)'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <path d='M12 10a2 2 0 0 0-2 2c0 1.02-.1 2.51-.26 4'></path>
    <path d='M14 13.12c0 2.38 0 6.38-1 8.88'></path>
    <path d='M17.29 21.02c.12-.6.43-2.3.5-3.02'></path>
    <path d='M2 12a10 10 0 0 1 18-6'></path>
    <path d='M2 16h.01'></path>
    <path d='M21.8 16c.2-2 .131-5.354 0-6'></path>
    <path d='M5 19.5C5.5 18 6 15 6 12a6 6 0 0 1 .34-2'></path>
    <path d='M8.65 22c.21-.66.45-1.32.57-2'></path>
    <path d='M9 6.8a6 6 0 0 1 9 5.2v2'></path>
  </svg>
);

export const simpleCreditCardSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    stroke='var(--main-text-color)'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <rect width='20' height='14' x='2' y='5' rx='2'></rect>
    <line x1='2' x2='22' y1='10' y2='10'></line>
  </svg>
);
export const trash2SVG = (
  <svg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg' fill='#000000'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10 3h3v1h-1v9l-1 1H4l-1-1V4H2V3h3V2a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v1zM9 2H6v1h3V2zM4 13h7V4H4v9zm2-8H5v7h1V5zm1 0h1v7H7V5zm2 0h1v7H9V5z'
    />
  </svg>
);

export const openAISVG = (
  <svg viewBox='0 0 24 24'>
    <path d='M22.2819 9.8211a5.9847 5.9847 0 0 0-.5157-4.9108 6.0462 6.0462 0 0 0-6.5098-2.9A6.0651 6.0651 0 0 0 4.9807 4.1818a5.9847 5.9847 0 0 0-3.9977 2.9 6.0462 6.0462 0 0 0 .7427 7.0966 5.98 5.98 0 0 0 .511 4.9107 6.051 6.051 0 0 0 6.5146 2.9001A5.9847 5.9847 0 0 0 13.2599 24a6.0557 6.0557 0 0 0 5.7718-4.2058 5.9894 5.9894 0 0 0 3.9977-2.9001 6.0557 6.0557 0 0 0-.7475-7.0729zm-9.022 12.6081a4.4755 4.4755 0 0 1-2.8764-1.0408l.1419-.0804 4.7783-2.7582a.7948.7948 0 0 0 .3927-.6813v-6.7369l2.02 1.1686a.071.071 0 0 1 .038.052v5.5826a4.504 4.504 0 0 1-4.4945 4.4944zm-9.6607-4.1254a4.4708 4.4708 0 0 1-.5346-3.0137l.142.0852 4.783 2.7582a.7712.7712 0 0 0 .7806 0l5.8428-3.3685v2.3324a.0804.0804 0 0 1-.0332.0615L9.74 19.9502a4.4992 4.4992 0 0 1-6.1408-1.6464zM2.3408 7.8956a4.485 4.485 0 0 1 2.3655-1.9728V11.6a.7664.7664 0 0 0 .3879.6765l5.8144 3.3543-2.0201 1.1685a.0757.0757 0 0 1-.071 0l-4.8303-2.7865A4.504 4.504 0 0 1 2.3408 7.872zm16.5963 3.8558L13.1038 8.364 15.1192 7.2a.0757.0757 0 0 1 .071 0l4.8303 2.7913a4.4944 4.4944 0 0 1-.6765 8.1042v-5.6772a.79.79 0 0 0-.407-.667zm2.0107-3.0231l-.142-.0852-4.7735-2.7818a.7759.7759 0 0 0-.7854 0L9.409 9.2297V6.8974a.0662.0662 0 0 1 .0284-.0615l4.8303-2.7866a4.4992 4.4992 0 0 1 6.6802 4.66zM8.3065 12.863l-2.02-1.1638a.0804.0804 0 0 1-.038-.0567V6.0742a4.4992 4.4992 0 0 1 7.3757-3.4537l-.142.0805L8.704 5.459a.7948.7948 0 0 0-.3927.6813zm1.0976-2.3654l2.602-1.4998 2.6069 1.4998v2.9994l-2.5974 1.4997-2.6067-1.4997Z'></path>
  </svg>
);

export const googleMapsSVG = (
  <svg viewBox='0 0 24 24'>
    <path d='M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z'></path>
  </svg>
);

export const anthropicSVG = (
  <svg viewBox='0 0 24 24'>
    <path d='M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5'></path>
  </svg>
);
export const bulbSVG = (
  <svg
    width='24'
    height='24'
    viewBox='0 0 1024 1024'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M492.373 20.482v76.401c0 11.311 9.169 20.48 20.48 20.48s20.48-9.169 20.48-20.48V20.482c0-11.311-9.169-20.48-20.48-20.48s-20.48 9.169-20.48 20.48m-269.704 92.457 38.195 66.161c5.655 9.796 18.18 13.152 27.976 7.497s13.152-18.18 7.497-27.976L258.142 92.46c-5.655-9.796-18.18-13.152-27.976-7.497s-13.152 18.18-7.497 27.976M61.441 310.666l66.161 38.195c9.796 5.655 22.321 2.299 27.976-7.497s2.299-22.321-7.497-27.976L81.92 275.193c-9.796-5.655-22.321-2.299-27.976 7.497s-2.299 22.321 7.497 27.976m836.66 38.2 66.161-38.195c9.796-5.655 13.152-18.18 7.497-27.976s-18.18-13.152-27.976-7.497l-66.161 38.195c-9.796 5.655-13.152 18.18-7.497 27.976s18.18 13.152 27.976 7.497M764.837 179.103l38.195-66.161c5.655-9.796 2.299-22.321-7.497-27.976s-22.321-2.299-27.976 7.497l-38.195 66.161c-5.655 9.796-2.299 22.321 7.497 27.976s22.321 2.299 27.976-7.497M619.705 609.548a20.48 20.48 0 0 1 9.029-16.979c53.847-36.315 86.469-95.279 86.469-159.497 0-107.392-90.442-194.744-202.353-194.744s-202.353 87.353-202.353 194.744c0 64.218 32.623 123.181 86.469 159.497a20.48 20.48 0 0 1 9.029 16.979v181.903c0 22.143 17.946 40.09 40.09 40.09h133.54c22.134 0 40.079-17.947 40.079-40.09V609.548zm40.96 181.904c0 44.763-36.283 81.05-81.039 81.05h-133.54c-44.765 0-81.05-36.285-81.05-81.05V620.14c-59.555-44.178-95.498-112.657-95.498-187.067 0-130.338 109.092-235.704 243.313-235.704s243.313 105.366 243.313 235.704c0 74.41-35.943 142.89-95.498 187.067v171.312zM410.986 949.054h203.735c11.311 0 20.48-9.169 20.48-20.48s-9.169-20.48-20.48-20.48H410.986c-11.311 0-20.48 9.169-20.48 20.48s9.169 20.48 20.48 20.48m25.467 76.4h152.801c11.311 0 20.48-9.169 20.48-20.48s-9.169-20.48-20.48-20.48H436.453c-11.311 0-20.48 9.169-20.48 20.48s9.169 20.48 20.48 20.48' />
  </svg>
);
export const chatSquareSVG = (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      d='m8.35 18-4.725 3.78A1 1 0 0 1 2 21V5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3zM4 18.92l3.375-2.7A1 1 0 0 1 8 16h11a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1z'
    />
  </svg>
);

export const documentSVG = (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M4 4a2 2 0 0 1 2-2h8a1 1 0 0 1 .707.293l5 5A1 1 0 0 1 20 8v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm13.586 4L14 4.414V8zM12 4H6v16h12V10h-5a1 1 0 0 1-1-1zm-4 9a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1' />
  </svg>
);

export const thumbUpSVG = (
  <svg
    width='20'
    height='20'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7 22V11M2 13V20C2 21.1046 2.89543 22 4 22H16.4262C17.907 22 19.1662 20.9197 19.3914 19.4562L20.4683 12.4562C20.7479 10.6389 19.3411 9 17.5032 9H14C13.4477 9 13 8.55228 13 8V4.46584C13 3.10399 11.896 2 10.5342 2C10.2093 2 9.91498 2.1913 9.78306 2.48812L7.26394 8.57843C7.11196 8.91878 6.76087 9.125 6.38197 9.125H4C2.89543 9.125 2 10.0204 2 11.125V13C2 13.5523 2.44772 14 3 14H4C4.55228 14 5 13.5523 5 13V11.125C5 10.5727 5.44772 10.125 6 10.125H7V22Z'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
  </svg>
);

export const thumbDownSVG = (
  <svg
    width='20'
    height='20'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M17 2V13M22 11V4C22 2.89543 21.1046 2 20 2H7.57377C6.09296 2 4.83384 3.08029 4.60858 4.54382L3.53165 11.5438C3.25213 13.3611 4.65888 15 6.49684 15H10C10.5523 15 11 15.4477 11 16V19.5342C11 20.896 12.104 22 13.4658 22C13.7907 22 14.085 21.8087 14.2169 21.5119L16.7361 15.4216C16.888 15.0812 17.2391 14.875 17.618 14.875H20C21.1046 14.875 22 13.9796 22 12.875V11C22 10.4477 21.5523 10 21 10H20C19.4477 10 19 10.4477 19 11V12.875C19 13.4273 18.5523 13.875 18 13.875H17V2Z'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
  </svg>
);

export const sendSVG = (
  <svg
    width='20'
    height='20'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M24 0l-6 22-8.129-7.239 7.802-8.234-10.458 7.227-7.215-1.754 24-12zm-15 16.668v7.332l3.258-4.431-3.258-2.901z' />
  </svg>
);
